<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" v-bind:variant="variant" v-show="!isGame">
      <!-- <div id="nav-collapse" class="collapse mr-auto navbar-collapse" style="display: none;width: 200px;"></div> -->

      <div class="header-l mr-auto nav-menu text-left">
        <div class="d-block">
          <b-nav-form style="display: block !important;">
            <span class="btn-group nav-buttons">
              <b-button v-bind:variant="variantNavButton" v-on:click="navigateTo('/menu')" class="btn-icon" v-if="!whiteLabel">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
                </svg>
              </b-button>
              <b-button v-bind:variant="variantNavButton" v-b-modal.modal-intro class="btn-icon" v-if="!whiteLabel">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                  <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"/>
                </svg>
              </b-button>

              <!-- <span class="btn-group"> -->
                <b-button v-bind:variant="variantNavButton" v-on:click="doUpload()" v-if="$route.path === '/' || $route.path === '/tang' || $route.path === '/dob' || $route.path === '/preme'">
                  UPLOAD 
                  <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
                  </svg> -->
                </b-button>
                <b-button v-bind:variant="variantNavButton" v-on:click="doUploadAvatar" v-if="!canBuy && $route.path === '/' && connectAccountEnsAvatar != ''" class="btn-icon">
                  <img v-bind:src="connectAccountEnsAvatar" class="ensAvatar">
                </b-button>
              <!-- </span> -->
              
            </span>
          </b-nav-form>
        </div>
      </div>

      <div class="mr-0 p-0 header-m">
        <span class="honk-text mbh-title" v-on:click="navigateTo('/')" v-if="!whiteLabel">Million Bit Homepage</span>
        <p class="subtitle dm-sans-text" v-if="!canBuy">
          1,000,000 pixels 
          • <span v-if="ethTokenToggle"><span v-text="ethPerPixel"></span> <span>ETH</span></span>
          <span v-if="!ethTokenToggle"><span v-text="tokenPerPixel"></span> <span v-text="symbol"></span></span>
           per pixel 
          • Own a bit of onchain history!
        </p>

        <div class="d-block text-center mb-3" v-if="canBuy">
          <b-nav-form class="text-center">
            <span class="btn-group" v-if="canToggleEthToken">
              <b-button v-bind:variant="variantNavButton" v-on:click="doToggleEthToken(true)" v-bind:class="{'btn-outline-lighter': !ethTokenToggle}">
                <span>ETH</span>
              </b-button>
              <b-button v-bind:variant="variantNavButton" v-on:click="doToggleEthToken(false)" v-bind:class="{'btn-outline-lighter': ethTokenToggle}">
                <span v-text="symbol"></span>
              </b-button>
            </span>
            <button type="button" class="btn" disabled style="color: white;">
              <span v-if="ethTokenToggle"><span v-text="ethAmtFormatted"></span> ETH</span>
              <span v-if="!ethTokenToggle"><span v-text="tokenAmt"></span> <span v-text="symbol"></span></span>
            </button>

            <b-form-input size="md" class="mr-md-2" placeholder="http link address" type="url" id="link-url" v-bind:value="formInputUrl" @keydown.enter.prevent="blurInput" ref="formInputValueUrl"></b-form-input>
            
            <b-button variant="warning" v-on:click="doBuy" v-if="canSend" v-bind:disabled="buyLoading">
              <span><div class="loader" v-if="buyLoading"></div> <span v-if="canMint">MINT</span><span v-else>SEND</span></span>
            </b-button>
            <!-- <b-button v-bind:variant="'sm'" v-on:click="cancelBuy">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
              </svg>
            </b-button> -->
          </b-nav-form>
        </div>
      </div>
  
      <div class="header-r ml-auto connect-menu text-right">

        <b-button id="connect-wallet" v-on:click="connectWallet()" v-if="!connectAccountAddress" class="btn btn-primary" v-bind:variant="'connect'">
          Connect Wallet
        </b-button>

        <span class="btn-group" v-if="connectAccountAddress">
          <b-button v-bind:variant="variantNavButton" v-on:click="navigateTo('/plots')">
            <span v-if="connectAccountEnsAvatar"><img v-bind:src="connectAccountEnsAvatar" style="border-radius: 50%;" /></span>
            <span v-if="connectAccountEnsName" v-text="connectAccountEnsNameTrunc"></span>
            <span v-if="!connectAccountEnsName" v-text="connectAccountAddressTrunc"></span>
          </b-button>
          <b-button class="disconnect" v-bind:variant="variantNavButton" v-on:click="doDisconnect()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-right" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"/>
              <path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"/>
            </svg>
          </b-button>
        </span>
        <div v-if="connectAccountAddress && !isBaseChain(connectAccountChainId)" class="my-2">
          <b-button v-bind:variant="'warning'" v-on:click="switchToBaseChain()">Switch to Base</b-button>
        </div>
      </div>
      <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->
    </b-navbar>

    <div class="promo-header" v-if="showPromo">
      🔥 {{ promoMsg }} 🔥
    </div>

    <router-view ref="routerViewRef"></router-view>

    <div id="countdown" class="mb-5" v-show="!isGame">
      <p class="text-bold" v-if="!whiteLabel">Pixel price goes up with each minted plot!</p>
      <p class="text-bold" v-if="whiteLabel">Powered by the <a href="https://millionbithomepage.com" target="_blank">Million Bit Homepage</a></p>
      <!-- <p class="text-center">PLOTS MINTED
        <span v-text="totalPlots"></span>
      </p> -->
      <!-- <ul>
        <li><span id="days"></span>days</li>
        <li><span id="hours"></span>Hours</li>
        <li><span id="minutes"></span>Minutes</li>
        <li><span id="seconds"></span>Seconds</li>
      </ul> -->
    </div>

    <b-modal id="modal-connect" title="Connect your wallet" hide-footer size="sm">
      <b-button id="create-wallet" v-on:click="createWallet()" v-if="!connectAccountAddress" class="btn btn-block btn-primary mb-4" v-bind:variant="'connect'">
        <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+">
         Create Wallet
      </b-button>
      <a v-bind:href="deepLinkMetamask" target="_blank" v-if="!connectAccountAddress && providers.length === 0" class="btn btn-block btn-primary mb-4"><img src="data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjMzIiB2aWV3Qm94PSIwIDAgMzUgMzMiIHdpZHRoPSIzNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iLjI1Ij48cGF0aCBkPSJtMzIuOTU4MiAxLTEzLjEzNDEgOS43MTgzIDIuNDQyNC01LjcyNzMxeiIgZmlsbD0iI2UxNzcyNiIgc3Ryb2tlPSIjZTE3NzI2Ii8+PGcgZmlsbD0iI2UyNzYyNSIgc3Ryb2tlPSIjZTI3NjI1Ij48cGF0aCBkPSJtMi42NjI5NiAxIDEzLjAxNzE0IDkuODA5LTIuMzI1NC01LjgxODAyeiIvPjxwYXRoIGQ9Im0yOC4yMjk1IDIzLjUzMzUtMy40OTQ3IDUuMzM4NiA3LjQ4MjkgMi4wNjAzIDIuMTQzNi03LjI4MjN6Ii8+PHBhdGggZD0ibTEuMjcyODEgMjMuNjUwMSAyLjEzMDU1IDcuMjgyMyA3LjQ2OTk0LTIuMDYwMy0zLjQ4MTY2LTUuMzM4NnoiLz48cGF0aCBkPSJtMTAuNDcwNiAxNC41MTQ5LTIuMDc4NiAzLjEzNTggNy40MDUuMzM2OS0uMjQ2OS03Ljk2OXoiLz48cGF0aCBkPSJtMjUuMTUwNSAxNC41MTQ5LTUuMTU3NS00LjU4NzA0LS4xNjg4IDguMDU5NzQgNy40MDQ5LS4zMzY5eiIvPjxwYXRoIGQ9Im0xMC44NzMzIDI4Ljg3MjEgNC40ODE5LTIuMTYzOS0zLjg1ODMtMy4wMDYyeiIvPjxwYXRoIGQ9Im0yMC4yNjU5IDI2LjcwODIgNC40Njg5IDIuMTYzOS0uNjEwNS01LjE3MDF6Ii8+PC9nPjxwYXRoIGQ9Im0yNC43MzQ4IDI4Ljg3MjEtNC40NjktMi4xNjM5LjM2MzggMi45MDI1LS4wMzkgMS4yMzF6IiBmaWxsPSIjZDViZmIyIiBzdHJva2U9IiNkNWJmYjIiLz48cGF0aCBkPSJtMTAuODczMiAyOC44NzIxIDQuMTU3MiAxLjk2OTYtLjAyNi0xLjIzMS4zNTA4LTIuOTAyNXoiIGZpbGw9IiNkNWJmYjIiIHN0cm9rZT0iI2Q1YmZiMiIvPjxwYXRoIGQ9Im0xNS4xMDg0IDIxLjc4NDItMy43MTU1LTEuMDg4NCAyLjYyNDMtMS4yMDUxeiIgZmlsbD0iIzIzMzQ0NyIgc3Ryb2tlPSIjMjMzNDQ3Ii8+PHBhdGggZD0ibTIwLjUxMjYgMjEuNzg0MiAxLjA5MTMtMi4yOTM1IDIuNjM3MiAxLjIwNTF6IiBmaWxsPSIjMjMzNDQ3IiBzdHJva2U9IiMyMzM0NDciLz48cGF0aCBkPSJtMTAuODczMyAyOC44NzIxLjY0OTUtNS4zMzg2LTQuMTMxMTcuMTE2N3oiIGZpbGw9IiNjYzYyMjgiIHN0cm9rZT0iI2NjNjIyOCIvPjxwYXRoIGQ9Im0yNC4wOTgyIDIzLjUzMzUuNjM2NiA1LjMzODYgMy40OTQ2LTUuMjIxOXoiIGZpbGw9IiNjYzYyMjgiIHN0cm9rZT0iI2NjNjIyOCIvPjxwYXRoIGQ9Im0yNy4yMjkxIDE3LjY1MDctNy40MDUuMzM2OS42ODg1IDMuNzk2NiAxLjA5MTMtMi4yOTM1IDIuNjM3MiAxLjIwNTF6IiBmaWxsPSIjY2M2MjI4IiBzdHJva2U9IiNjYzYyMjgiLz48cGF0aCBkPSJtMTEuMzkyOSAyMC42OTU4IDIuNjI0Mi0xLjIwNTEgMS4wOTEzIDIuMjkzNS42ODg1LTMuNzk2Ni03LjQwNDk1LS4zMzY5eiIgZmlsbD0iI2NjNjIyOCIgc3Ryb2tlPSIjY2M2MjI4Ii8+PHBhdGggZD0ibTguMzkyIDE3LjY1MDcgMy4xMDQ5IDYuMDUxMy0uMTAzOS0zLjAwNjJ6IiBmaWxsPSIjZTI3NTI1IiBzdHJva2U9IiNlMjc1MjUiLz48cGF0aCBkPSJtMjQuMjQxMiAyMC42OTU4LS4xMTY5IDMuMDA2MiAzLjEwNDktNi4wNTEzeiIgZmlsbD0iI2UyNzUyNSIgc3Ryb2tlPSIjZTI3NTI1Ii8+PHBhdGggZD0ibTE1Ljc5NyAxNy45ODc2LS42ODg2IDMuNzk2Ny44NzA0IDQuNDgzMy4xOTQ5LTUuOTA4N3oiIGZpbGw9IiNlMjc1MjUiIHN0cm9rZT0iI2UyNzUyNSIvPjxwYXRoIGQ9Im0xOS44MjQyIDE3Ljk4NzYtLjM2MzggMi4zNTg0LjE4MTkgNS45MjE2Ljg3MDQtNC40ODMzeiIgZmlsbD0iI2UyNzUyNSIgc3Ryb2tlPSIjZTI3NTI1Ii8+PHBhdGggZD0ibTIwLjUxMjcgMjEuNzg0Mi0uODcwNCA0LjQ4MzQuNjIzNi40NDA2IDMuODU4NC0zLjAwNjIuMTE2OS0zLjAwNjJ6IiBmaWxsPSIjZjU4NDFmIiBzdHJva2U9IiNmNTg0MWYiLz48cGF0aCBkPSJtMTEuMzkyOSAyMC42OTU4LjEwNCAzLjAwNjIgMy44NTgzIDMuMDA2Mi42MjM2LS40NDA2LS44NzA0LTQuNDgzNHoiIGZpbGw9IiNmNTg0MWYiIHN0cm9rZT0iI2Y1ODQxZiIvPjxwYXRoIGQ9Im0yMC41OTA2IDMwLjg0MTcuMDM5LTEuMjMxLS4zMzc4LS4yODUxaC00Ljk2MjZsLS4zMjQ4LjI4NTEuMDI2IDEuMjMxLTQuMTU3Mi0xLjk2OTYgMS40NTUxIDEuMTkyMSAyLjk0ODkgMi4wMzQ0aDUuMDUzNmwyLjk2Mi0yLjAzNDQgMS40NDItMS4xOTIxeiIgZmlsbD0iI2MwYWM5ZCIgc3Ryb2tlPSIjYzBhYzlkIi8+PHBhdGggZD0ibTIwLjI2NTkgMjYuNzA4Mi0uNjIzNi0uNDQwNmgtMy42NjM1bC0uNjIzNi40NDA2LS4zNTA4IDIuOTAyNS4zMjQ4LS4yODUxaDQuOTYyNmwuMzM3OC4yODUxeiIgZmlsbD0iIzE2MTYxNiIgc3Ryb2tlPSIjMTYxNjE2Ii8+PHBhdGggZD0ibTMzLjUxNjggMTEuMzUzMiAxLjEwNDMtNS4zNjQ0Ny0xLjY2MjktNC45ODg3My0xMi42OTIzIDkuMzk0NCA0Ljg4NDYgNC4xMjA1IDYuODk4MyAyLjAwODUgMS41Mi0xLjc3NTItLjY2MjYtLjQ3OTUgMS4wNTIzLS45NTg4LS44MDU0LS42MjIgMS4wNTIzLS44MDM0eiIgZmlsbD0iIzc2M2UxYSIgc3Ryb2tlPSIjNzYzZTFhIi8+PHBhdGggZD0ibTEgNS45ODg3MyAxLjExNzI0IDUuMzY0NDctLjcxNDUxLjUzMTMgMS4wNjUyNy44MDM0LS44MDU0NS42MjIgMS4wNTIyOC45NTg4LS42NjI1NS40Nzk1IDEuNTE5OTcgMS43NzUyIDYuODk4MzUtMi4wMDg1IDQuODg0Ni00LjEyMDUtMTIuNjkyMzMtOS4zOTQ0eiIgZmlsbD0iIzc2M2UxYSIgc3Ryb2tlPSIjNzYzZTFhIi8+PHBhdGggZD0ibTMyLjA0ODkgMTYuNTIzNC02Ljg5ODMtMi4wMDg1IDIuMDc4NiAzLjEzNTgtMy4xMDQ5IDYuMDUxMyA0LjEwNTItLjA1MTloNi4xMzE4eiIgZmlsbD0iI2Y1ODQxZiIgc3Ryb2tlPSIjZjU4NDFmIi8+PHBhdGggZD0ibTEwLjQ3MDUgMTQuNTE0OS02Ljg5ODI4IDIuMDA4NS0yLjI5OTQ0IDcuMTI2N2g2LjExODgzbDQuMTA1MTkuMDUxOS0zLjEwNDg3LTYuMDUxM3oiIGZpbGw9IiNmNTg0MWYiIHN0cm9rZT0iI2Y1ODQxZiIvPjxwYXRoIGQ9Im0xOS44MjQxIDE3Ljk4NzYuNDQxNy03LjU5MzIgMi4wMDA3LTUuNDAzNGgtOC45MTE5bDIuMDAwNiA1LjQwMzQuNDQxNyA3LjU5MzIuMTY4OSAyLjM4NDIuMDEzIDUuODk1OGgzLjY2MzVsLjAxMy01Ljg5NTh6IiBmaWxsPSIjZjU4NDFmIiBzdHJva2U9IiNmNTg0MWYiLz48L2c+PC9zdmc+"> Metamask</a>
      <a v-bind:href="deepLinkCoinbase" target="_blank" v-if="!connectAccountAddress && providers.length === 0" class="btn btn-block btn-primary mb-4"><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+"> Coinbase</a>
      <span v-for="provider in providers">
        <b-button v-if="!connectAccountAddress" class="btn-block btn-primary mb-4" v-bind:variant="'connect'" v-on:click="doConnect(provider)" v-bind:disabled="isConnecting">
          <img v-bind:src="provider.info.icon" /> {{ provider.info.name }}
        </b-button>
      </span>
    </b-modal>


    <b-modal id="modal-token" title="Own a bit of blockchain history!" hide-footer size="lg">
      <h2 v-text="symbol"></h2>
      <div class="row">
        <div class="col-12">
          <a href="#" class="btn btn-block btn-outline-dark btn-lg"><svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg>
          <span v-text="contractAddress" v-on:click="doCopyToClipboard(contractAddress)"></span></a>
          <br />
          <a href="#" class="btn btn-outline-dark btn-block" v-on:click="watchToken()">Watch token in wallet</a>
          <br />
        </div>
        <br /><br />
        <br />
      </div>

    <h2>Launch status</h2>
    <p>Coming soon.. join us on telegram for updates on the upcoming launch!</p>

      <!-- <div class="row">
        <div class="col-6">
          <a href="#" class="btn btn-block btn-warning btn-lg">🔁 SWAP</a>
        </div>
        <div class="col-6">
          <a href="#" class="btn btn-block btn-warning btn-lg">📈 CHART</a>
        </div>
      </div>
      <hr />
      <h2>Tokenomics</h2>
      <p>90% LP</p>
      <p>10% TREASURY</p>

      <h2>Utility</h2>
      <p>Used to get a piece of the Million Bit Hompeage.  Put pixels onchain to support your favorite project.</p> -->
    </b-modal>

    <b-modal id="modal-alert" hide-header hide-footer size="lg">
      <h3 v-text="alertMsg" class="text-center"></h3>
    </b-modal>

    <b-modal id="modal-intro" title="👋 Welcome to the Million Bit Homepage!" hide-footer size="lg">
      <p>
        Add your image to the homepage and be forever immortalized on the blockchain!
      </p>

      <h3 class="my-4">💰 What you get</h3>
      <p class="text-left">
        <b>NFT of your plot!</b><br />
        You own your plot forever.  You can list it on marketplaces like 
        <!-- <a href="https://opensea.io/collection/million-bit-homepage" target="_blank">OpenSea</a> & -->
        <a href="https://magiceden.us/collections/base/0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e" target="_blank">Magic Eden</a> and <a @click.prevent="navigateTo('/plots')" href="#">update your plot</a>.
      </p>
      <p class="text-left">
        <b>Join the MBH community</b><br />
        Invited to speak in our weekly <a @click.prevent="navigateTo('/spaces')" href="#">Twitter X spaces</a> and access to our exclusive Twitter X group.
      </p>
      <p class="text-left">
        <b>Included in marketing and games</b><br />
        Instantly included in our games <a @click.prevent="navigateTo('/break')" href="#">Break</a> & <a @click.prevent="navigateTo('/drop')" href="#">Drop</a>, and marketing of the homepage.
      </p>

      <!-- <ul>
        <li>Own your plot forever! Minted as an NFT</li>
        <li>Ability to list and update your plot NFT</li>
        <li>Become instantly included in our Break game</li>
        <li>Invited to speak in weekly Twitter X spaces</li>
        <li>Access to the exclusive Twitter X Community</li>
        <li>Included in MBH marketing</li>
      </ul> -->
      <hr />

      <h3 class="my-4">👩‍🏫 How it works</h3>
      <!-- <p>
        Add your image and link using ETH <span v-if="canToggleEthToken">or <a v-text="symbol" v-b-modal.modal-token></a></span>.
      </p> -->
      <p class="text-left">
        <b class="pr-2">Step 1</b> 
        Click on the UPLOAD button.
      </p>
      <p class="text-left">
        <b class="pr-2">Step 2</b> 
        Move and resize your image.
      </p>
      <p class="text-left">
        <b class="pr-2">Step 3</b> 
        Click the MINT button.
      </p>
      <p class="text-left">
        <b class="pr-2">Step 4</b> 
        Check back in a minute to see your addition!
      </p>

      <hr />

      <h3 class="my-4">📽️ See it in action</h3>
      <p>
        Watch an example of how easy it is to claim your plot on the homepage.
      </p>
      <!-- <a href="https://x.com/BitHomepage/status/1809991768177246675" target="_blank" class="btn btn-primary btn-block">Watch video</a> -->
      <a href="#" class="btn btn-primary btn-block" @click.prevent="navigateTo('demo')">Watch video</a>
    </b-modal>

    <b-modal id="modal-success" title="You're a part of blockchain history!" hide-footer size="lg">
      <p>
        Thank you for being a part of blockchain history 💙
        <br /><a v-if="trxHashSuccess" v-bind:href="'https://basescan.org/tx/'+trxHashSuccess" target="_blank">View transaction</a>
        <br /><br />
        Please allow a few minutes to process your pixels from the blockchain and be added to the <span v-if="!whiteLabel">homepage</span><span v-if="!whiteLabel">page</span>.
        <br /><br />
        Make sure to join our community on <a v-bind:href="telegram" target="_blank">Telegram</a> and <a v-bind:href="twitter" target="_blank">Twitter</a>.
        <br /><br />
        <span v-if="!whiteLabel">Share with your friends and get 15% of the spots they buy!
        <br /><br />
        <a href="#" class="btn btn-block btn-outline-dark btn-lg">
          <span v-text="shareUrl" v-on:click="doCopyToClipboard(shareUrl)"></span>
        </a>
        </span>
      </p>
      <hr />
      <a v-bind:href="xPostSuccess" target="_blank" class="btn btn-block btn-lg btn-primary">Share on X</a><br />
    </b-modal>
    
    <b-modal id="modal-invite-friends" title="Invite Friends" hide-footer size="lg">
      <h1>Refer friends and earn 15%</h1>
      <p>
        Share the Million Bit Homepage with your friends and earn 15% of the spots they buy.
      </p>
      <span v-if="!connectAccountAddress">
        <b>Connect your wallet to get your referral link</b>
      </span>
      <span v-if="connectAccountAddress">
        <b>Share invite link</b>
        <a href="#" class="btn btn-block btn-outline-dark btn-lg">
          <span v-text="shareUrl" v-on:click="doCopyToClipboard(shareUrl)"></span>
        </a>
        <hr />
        <a v-bind:href="xPostInvite" target="_blank" class="btn btn-block btn-lg btn-primary">Share on X</a><br />
      </span>
    </b-modal>

    <div id="fine-uploader-manual-trigger" style="display:none;"></div> 

    <div id="mobile-controls" v-if="isMobileOrTouch && canBuy">
      <div id="control-down"
          @click="btnPress"
          @touchstart="handleTouchStart($event, 'down')"
          @touchend="handleTouchEnd"
          @touchcancel="handleTouchCancel">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"/>
        </svg>
      </div>
      <div id="control-left"
          @click="btnPress"
          @touchstart="handleTouchStart($event, 'left')"
          @touchend="handleTouchEnd"
          @touchcancel="handleTouchCancel">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
        </svg>
      </div>
      <div id="control-right"
          @click="btnPress"
          @touchstart="handleTouchStart($event, 'right')"
          @touchend="handleTouchEnd"
          @touchcancel="handleTouchCancel">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
        </svg>
      </div>
      <div id="control-up"
          @click="btnPress"
          @touchstart="handleTouchStart($event, 'up')"
          @touchend="handleTouchEnd"
          @touchcancel="handleTouchCancel">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"/>
        </svg>
      </div>
      <div id="control-smaller" v-on:click="resizeSpot('smaller')">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-out" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"/>
          <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"/>
          <path fill-rule="evenodd" d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"/>
        </svg>
      </div>
      <div id="control-bigger" v-on:click="resizeSpot('bigger')">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-in" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"/>
          <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"/>
          <path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"/>
        </svg>
      </div>
    </div> 
    
    <div class="bg-white mbh-footer" v-show="!isGame">
      <b-navbar variant="white">
        <b-navbar-brand href="#">
          <span class="honk-text">MBH</span>
        </b-navbar-brand>
        <b-navbar-nav>
          <b-nav-item v-bind:href="email" target="_blank" variant="link">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
              <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"/>
            </svg>
          </b-nav-item>
          <b-nav-item v-bind:href="telegram" target="_blank" variant="link">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telegram" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"/>
            </svg>
          </b-nav-item>
          <!-- <b-nav-item v-bind:href="discord" target="_blank" variant="link">Discord</b-nav-item> -->
          <b-nav-item v-bind:href="twitter" target="_blank" variant="link">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
              <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
            </svg>
          </b-nav-item>
          <b-nav-item variant="link" href="https://www.complainonchain.xyz/millionbithomepage" target="_blank" class="send-feedback"><img src="/static/keren.webp" /> Feedback</b-nav-item>
          <b-nav-item variant="link" @click.prevent="showInviteFriends()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-megaphone-fill" viewBox="0 0 16 16">
            <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25 25 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009l.496.008a64 64 0 0 1 1.51.048m1.39 1.081q.428.032.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a66 66 0 0 1 1.692.064q.491.026.966.06"/>
          </svg>
          Invite friends
        </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <!-- <b-button disabled variant="link">Made with 💙</b-button> -->
          <b-nav-item variant="link" @click.prevent="navigateTo('/terms')">Terms</b-nav-item>
          <b-nav-item variant="link" @click.prevent="navigateTo('/privacy')">Privacy</b-nav-item>
        </b-navbar-nav>
      </b-navbar>
      <b-button disabled variant="link" id="copyright">© 2025. All rights reserved. Not responsible for the content of external sites or images featured which are © of their respective owners.</b-button>
    </div>

    <div class="confetti-wrapper">
      <div class="js-container c-container"></div>
    </div>
    <div id="toast"></div>
    <div v-if="!watchedDemo && !whiteLabel" id="pfp-vid-container" @click.prevent="showDemoVideo">
      <div id="pfp-vid">
        <video src="/static/pfp-talking-head.webm" autoplay loop muted playsinline></video>
      </div>
    </div>
  </div>
</template>

<script>

/*global ethers*/
/*global ethereum*/
/*global qq*/
/*global interact*/
/*global pako*/
/*global _*/
var Buffer = require('buffer/').Buffer;
window.Buffer = Buffer;

import Vue from 'vue'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

import utils from './utils';
import config from './config';
import constants from './constants';

const DEMO_MODE = process.env.DEMO_MODE || false;
const DEMO_ADDRESS = process.env.DEMO_ADDRESS || false;
const WEBHOOK_URL = 'https://ta2f7ylhwu46yoen7xk2pvueee0qtjjt.lambda-url.us-west-2.on.aws/';
const PUSH_SUB_URL = 'https://nnwj3qjluewoavvztzguep5yse0dgbet.lambda-url.us-west-2.on.aws/';
const TOKEN_PIXEL_PRICE = 1;
const ETH_PIXEL_PRICE = DEMO_ADDRESS ? 0.000085 : 0.000085; // 0.000085 // $1 USD at 5/29/2024
const BID_TO_ADDRESS = DEMO_ADDRESS ? '0xCF6ecdA3F26F2fbd242Ec7f7Aa59a3B627e912ab' : '0x5493dB14A2b6fd71B531fa1CFc752FdFaD734AcD'; // MBH
const TOKEN_IMAGE_URL = 'https://millionbithomepage.com/static/favicon-32x32.png';
const ETH_NETWORK = '1'; // '1' is the Ethereum main network ID.
const BASE_NETWORK = '8453'; // Base Mainnet
const BASE_CHAIN_ID = '0x2105'; // Base Mainnet
const ETH_GAS_PRICE = process.env.ETH_GAS_PRICE || '0.000000002';
const ETH_GAS_LIMIT = process.env.ETH_GAS_LIMIT || 6000000; // max is around 8000000?
const PIXEL_PER_SQUARE = 16;
const MAX_IMAGE_SIZE = PIXEL_PER_SQUARE * 4;
const applicationServerPublicKey = 'BESOSUO9VPh2EnimIVXt9MjactiD21wbBivbfB4JZr5UWtVN8dQGUOg0uFzB9uWFdLPGfYFkCCDq3pv6XzNIGrQ';
const DID_PROMPT_NOTIFICATIONS = 'DID_PROMPT_NOTIFICATIONS';
const LOCAL_STORAGE_NOTIFICATION_SUB_ENDPOINT = 'NOTIFICATION_SUB_ENDPOINT';
const LOCAL_STORAGE_KEY_REFERRAL = 'REF_CODE';
const LOCAL_STORAGE_KEY_DEMO_VID = 'DEMO_VID';
const BASENAME_L2_RESOLVER_ADDRESS = '0xC6d566A56A1aFf6508b41f6c90ff131615583BCD';

const DO_LOG = process.env.NODE_ENV !== 'production';
function log() {
  if(DO_LOG) {
    console.log.apply(console, arguments);
  }
}

function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function trackEvent(t) {
  try {
    if (window.gtag) {
      gtag('event', t);
    }
  } catch(e) {
    console.error('Failed to track event', e);
  }
}

function doCountdown() {
  const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

  const countDownEndDate = new Date("10/10/2024");
  const countDown = countDownEndDate.getTime();
  window.countdownInterval = setInterval(function() {
    const now = new Date().getTime();
    let distance = countDown - now;
    if (distance < 0) {
      distance = 0;
      clearInterval(window.countdownInterval);
    }

    document.getElementById("days").innerText = Math.floor(distance / (day)),
    document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour)),
    document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute)),
    document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second);

    //do something later when date is reached
    if (distance < 0) {
      // document.getElementById("countdown").style.display = "none";
      clearInterval(window.countdownInterval);
    }
    //seconds
  }, 0);
}

function stringDataForEth(arr, url, bid, r, c) {
  const DATA_ENCODING_VERSION = 1;
  // for(var i in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]) {
  //   for(var ii in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]) {
  //     is.push(""+i+","+ii+"#0000ff");
  //   }
  // }
  // log('window offset', window.img_offset_x, window.img_offset_y);
  // log('STRING DATA FOR PIXEL DATA', arr, r, c, typeof r, typeof c)
  
  if(typeof r === 'string') {
    r = parseInt(r, 10);
  }
  if(typeof c === 'string') {
    c = parseInt(c, 10);
  }
  
  let colors = [];
  for(let i in arr) {
    let p = arr[i];
    colors.push(p['hex']);
  }
  let xOffset = ((window.img_offset_x / 16)+c);
  let yOffset = ((window.img_offset_y / 16)+r);
  log('stringDataForEth', window.img_offset_x, window.img_offset_y, xOffset, yOffset, c, r);
  return "v"+DATA_ENCODING_VERSION+"|"+xOffset+","+yOffset+"|"+colors.join(',')+"|"+bid+"|"+encodeURIComponent(url);
}

function getPriceForPosition(img_offset_x, img_offset_y, canvasWidth, canvasHeight, disallowExistingPixels) {
  let tokenCost = 0;
  // log('getPriceForPosition', img_offset_x, img_offset_y, canvasWidth, canvasHeight)
  window.segmentPrices = [];

  let coversExistingPixels = false;
  const pixelsPerSegment = 16 * 16;
  
  _.times(canvasHeight/16, function(h){
    let cols = [];
    _.times(canvasWidth/16, function(w){
      // log('get price for section', h, w)
      let price = "0.000";
      
      // FIND price in data
      let priceDoc = _.find(window.pricesData, { 'x': (img_offset_x/16)+w, 'y': (img_offset_y/16)+h });
      if(priceDoc) {
        price = priceDoc.p;
        coversExistingPixels = true;
      }
      
      // let sectionPriceInWei = ethers.parseEther(price).add(ethers.parseEther(DONATION_PIXEL_PRICE).mul(pixelsPerSegment));
      // costInWei = costInWei.add(sectionPriceInWei);
      let sectionPriceInWei = pixelsPerSegment;
      tokenCost = tokenCost + sectionPriceInWei;
      
      cols.push(tokenCost);
    });
    window.segmentPrices.push(cols)
  });

  if (disallowExistingPixels && coversExistingPixels) {
    return false;
  }
  
  // log('window.segmentPrices', window.segmentPrices)
  return tokenCost;
}

function getHexFromRgb(r, g, b) {
  return ("0" + r.toString(16)).slice(-2) + ("0" + g.toString(16)).slice(-2) + ("0" + b.toString(16)).slice(-2);
}

function getPixelsData(myImageData, width, height) {
  log('getPixelsData', myImageData, width, height)
  var pixels_arr = [];
  var p = 0;
  for(var i in myImageData) {
    if(i % 4 === 0) {
      pixels_arr[p] = {
        "r": myImageData[i]
      };
    } else if(i % 4 === 1) {
      pixels_arr[p]["g"] = myImageData[i];
    } else if(i % 4 === 2) {
      pixels_arr[p]["b"] = myImageData[i];
    } else if(i % 4 === 3) {
      pixels_arr[p]["a"] = myImageData[i];
      // log(pixels_arr[p]["a"])
      pixels_arr[p]["hex"] = getHexFromRgb(pixels_arr[p]["r"], pixels_arr[p]["g"], pixels_arr[p]["b"]);
      // if(p % canvas.width == 0) {
      //   log(pixels_arr[p])
      // }
      p++;
    }
  }
    
  let rows = []
  var ha = new Array(height / 16);
  var wa = new Array(width / 16);
  for(var hi = 0; hi < ha.length; hi++){ // for each vertical section
    let cols = [];
    for(var wi = 0; wi < wa.length; wi++){ // for each horizontal section
      cols.push([]);
    }
    rows.push(cols);
  }
  
  // rows is multidimension array to hold image data
  for(let row = 0; row < ha.length; row++){ // for each vertical section
    _.times(16, function(y){
      for(let col = 0; col < wa.length; col++){ // for each horizontal section
        _.times(16, function(x){
          rows[row][col].push(pixels_arr.shift());
        });
      }
    });
  }
  
  return rows;
}

function getScaledContext(origWidth, origHeight, width, height, imgd) {
  
  var newCanvas = document.createElement('canvas');
  newCanvas.width = width;
  newCanvas.height = height;
  newCanvas.style.visibility = 'hidden';
  
  document.body.appendChild(newCanvas);
  
  
  var destCtx = newCanvas.getContext("2d");

  var tmpCanvas = document.createElement('canvas');
  tmpCanvas.width = origWidth;
  tmpCanvas.height = origHeight;
  tmpCanvas.style.visibility = 'hidden';
  document.body.appendChild(tmpCanvas);
  
  tmpCanvas.getContext("2d").putImageData(imgd, 0, 0);
  
  destCtx.drawImage(tmpCanvas, 0, 0, width, height);
  
  return destCtx;
}

function fetchImage(url) {
  return fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const fileName = url.substring(url.lastIndexOf('/') + 1);
      return new File([blob], fileName, { type: blob.type });
    });
}

function initUploader(self) {
  log('initUploader')
  // if (!document.querySelector('#million-bit-billboard > img')) {
  //   return;
  // }
  window.img_offset_x = 0;
  window.img_offset_y = 0;
  
  if(window.manualUploader) {
    utils.clearDraggableImage();
    window.manualUploader.reset();
    delete window.manualUploader;
  }
  
  if(window.interactable) {
    window.interactable.unset();
    delete window.interactable;
  }
  
  if(self.loader) {
    self.loader.hide();
  }
  
  function resizeImageMax(canvas, img) {
    // Resize if too large
    let maxSize = MAX_IMAGE_SIZE;
    let width = canvas.width;
    let height = canvas.height;
    if (width > height) {
      if (width > maxSize) {
          height *= maxSize / width;
          width = maxSize;
        }
    } else {
      if (height > maxSize) {
        width *= maxSize / height;
        height = maxSize;
      }
    }

    // Scale to PIXEL_PER_SQUARE 
    if(width % PIXEL_PER_SQUARE !== 0) {
      width = width - (width % PIXEL_PER_SQUARE);
    }
    if(height % PIXEL_PER_SQUARE !== 0) {
      height = height - (height % PIXEL_PER_SQUARE);
    }
    return { canvasWidth: width, canvasHeight: height }
  }

  window.uploadedImgData = null;

  window.manualUploader = new qq.FineUploader({
      element: document.getElementById('fine-uploader-manual-trigger'),
      template: 'qq-template-manual-trigger',
      callbacks: {
        onStatusChange: function(id, old, newStatus) {
          log("onStatusChange", arguments);
          if(newStatus === 'submitting') {
            log('submitting');
            self.loader = self.$loading.show({
              // Optional parameters
              // container: this.fullPage ? null : this.$refs.formContainer,
              // canCancel: true,
              // onCancel: this.onCancel,
            });
          } else if (newStatus === 'submitted') {
            log('submitted');
          } else if (newStatus === 'rejected') {
            this.reset();
            self.loader.hide();
            self.showAlert('The selected image is too large.')
          }
        },
        // onSubmitted: function(id) {
        //   log("onSubmitted", self)
        // },
        // onSubmit: function(id) {
        //   log("onSubmit", self)
        // },
        // onCancel: function(id) {
        //   log("CANCELED")
        // },
        // onProgress: function(id) {
        //   log("onProgress")
        // },
        // onValidate: function(id) {
        //   log("onValidate")
        // },
        // onError: function(id) {
        //   log("onError", arguments)
        // },
      },
      thumbnails: {
          // placeholders: {
          //     waitingPath: '/source/placeholders/waiting-generic.png',
          //     notAvailablePath: '/source/placeholders/not_available-generic.png'
          // },
        customResizer: function(resizeInfo) {
          return new Promise(function(resolve, reject) {
            // log(resizeInfo.sourceCanvas)
            var canvas = resizeInfo.sourceCanvas;
            
            log("Uploaded image", canvas.width, canvas.height, canvas);
            trackEvent('uploadedImage');
            trackEvent('add_to_cart');

            self.saveEvent('uploadedImage', {
            });
           
            document.getElementById('million-bit-billboard').classList.add('tooltip-place');
            
            var ctx = resizeInfo.sourceCanvas.getContext('2d');
            // log('canvas size', canvas.width, canvas.height)
            
            let { canvasWidth, canvasHeight } = resizeImageMax(canvas);
            var imgd = ctx.getImageData(0, 0, canvas.width, canvas.height);
            var myImageData = imgd.data;
            window.uploadedImgObj = {data: imgd, width: canvas.width, height: canvas.height};
            
            var c=document.getElementById("uploadedImg");
            c.style.display = 'block';
            c.width = canvas.width;
            c.height = canvas.height;
            c.style.width = canvasWidth+'px';
            c.style.height = canvasHeight+'px';
            var uploadedImgCtx = c.getContext("2d");
            
            // Replace transparent pixels with white
            utils.replaceTransparent(myImageData);
            
            uploadedImgCtx.putImageData(imgd, 0, 0);

            window.img_offset_x = 0;
            window.img_offset_y = 0;
            window.img_width = canvasWidth;
            window.img_height = canvasHeight;
            log('customResizer', canvasWidth, canvasHeight)
           
            var destCtx = getScaledContext(c.width, c.height, canvasWidth, canvasHeight, imgd);
            let d = destCtx.getImageData(0, 0, canvasWidth, canvasHeight).data
            myImageData = d;

            // let canvasPixels = (canvasWidth * canvasHeight);
            // Check if we have a spot we would like to place this
            // console.log(`Checking if we have a spot we would like to place this image on`, self.uploadToXY);
            if (self.uploadToXY && self.uploadToXY.x && self.uploadToXY.y) {
              // console.log(`Placing image on spot`, self.uploadToXY);
              self.moveImage(self.uploadToXY.x, self.uploadToXY.y, true);
              self.uploadToXY = null;
            }

            self.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);

            // target elements with the "draggable" class
            window.interactable = interact('#uploadedImg')
             .resizable({
                origin: 'parent',
                edges: {
                  top   : false,
                  left  : false,
                  bottom: true,
                  right : true
                },
                modifiers: [
                  // https://interactjs.io/docs/snapping/#snapsize
                  interact.modifiers.snapSize({
                    targets: [
                      interact.snappers.grid({ width: 16, height: 16 }),
                    ],
                  }),
                  // https://interactjs.io/docs/snapping/#snap
                  // interact.modifiers.snap({
                  //   targets: [
                  //     interact.createSnapGrid({ x: 16, y: 16 })
                  //   ],
                  //   relativePoints: [ { x: 0, y: 0 } ]
                  // }),
                  interact.modifiers.restrictSize({
                    min: { width: 16, height: 16 },
                    max: { width: MAX_IMAGE_SIZE, height: MAX_IMAGE_SIZE }
                  })
                ],
              })
              .on('resizemove', event => {
                log('resizemove', event.rect.width, event.rect.height);
                // let { x, y } = event.target.dataset
                // document.getElementById('million-bit-billboard').classList.remove('tooltip-place');
            
                Object.assign(event.target.style, {
                  width: `${event.rect.width}px`,
                  height: `${event.rect.height}px`,
                  // transform: `translate(${event.deltaRect.left}px, ${event.deltaRect.top}px)`
                });
                window.img_width = event.rect.width;
                window.img_height = event.rect.height;
                
                var destCtx = getScaledContext(c.width, c.height, event.rect.width, event.rect.height, imgd);
                let d = destCtx.getImageData(0, 0, event.rect.width, event.rect.height).data
                window.myImageData = d;
                // window.pixels_data = getPixelsData(d, event.rect.width, event.rect.height);
                // log(window.pixels_data)
                self.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
                // self.setEthAmt(getPriceForPosition(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height));
                // Object.assign(event.target.dataset, { x, y })
              })
              .draggable({
                origin: 'parent',
                inertia: false, // disable inertial throwing
                // keep the element within the area of it's parent
                // edges: { top: true, left: true },
                modifiers: [
                  interact.modifiers.snap({
                    targets: [
                      interact.createSnapGrid({ x: 16, y: 16 })
                    ],
                    relativePoints: [ { x: 0, y: 0 } ]
                  }),
                  interact.modifiers.restrict({
                    restriction: "parent",
                    endOnly: false,
                    elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
                  }),
                ],
                autoScroll: true,
                // call this function on every dragmove event
                onmove: dragMoveListener,
                // call this function on every dragend event
                onend: function (event) {
                  var parentPos = document.getElementById('million-bit-billboard').getBoundingClientRect();
                  var childrenPos = document.getElementById('uploadedImg').getBoundingClientRect()
                  window.img_offset_x = Math.floor(childrenPos.left - parentPos.left);
                  window.img_offset_y = Math.floor(childrenPos.top - parentPos.top);
                  // Update price
                  // log('Set price for position', window.img_offset_x, window.img_offset_y, 'size', window.img_width, window.img_height);
                  self.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
                }
              });
              
            function dragMoveListener (event) {
              // document.getElementById('million-bit-billboard').classList.remove('tooltip-place');
              var target = event.target,
                  // keep the dragged position in the data-x/data-y attributes
                  x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
                  y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
          
              // translate the element
              // target.style.webkitTransform =
              target.style.transform =
                'translate(' + x + 'px, ' + y + 'px)';
          
              // update the position attributes
              target.setAttribute('data-x', x);
              target.setAttribute('data-y', y);
            }

            window.interactable.reflow({ name: 'drag', axis: 'xy' });
            
            window.myImageData = myImageData;
            // window.pixels_data = getPixelsData(myImageData, canvas.width, canvas.height);
            // log(window.pixels_data)
            // log('pixel data done....');
            self.loader.hide();
            self.canBuy = true;
            
            resolve();
          });
        },
      },
      autoUpload: false,
      debug: DO_LOG,
      validation: {
        allowedExtensions: ["jpeg", "jpg", "png"],
        acceptFiles: "image/jpeg, image/png",
        stopOnFirstInvalidFile: true,
        sizeLimit: 1000 * 1000
      }
  });
}

function getEncodedEthDataValue(DATA_VALUE_UNENCODED) {
  return ethers.AbiCoder.defaultAbiCoder().encode([{"name":"_value","type":"string"}], [DATA_VALUE_UNENCODED]);
}

function pollForCompletion (txHash, callback) {
  let calledBack = false;

  // Normal ethereum blocks are approximately every 15 seconds.
  // Here we'll poll every 2 seconds.
  const checkInterval = setInterval(function () {

    const notYet = 'response has no error or result';
    
    ethereum.sendAsync({
      method: 'eth_getTransactionByHash',
      params: [ txHash ],
    }, function (err, response) {
      if (calledBack) return;
      if (err || response.error) {
        if (err.message.includes(notYet)) {
          return 'transaction is not yet mined';
        }
        callback(err || response.error);
      }
      // We have successfully verified the mined transaction.
      // Mind you, we should do this server side, with our own blockchain connection.
      // Client side we are trusting the user's connection to the blockchain.
      const transaction = response.result;
      clearInterval(checkInterval);
      calledBack = true;
      callback(null, transaction);
    });
  }, 2000);
}

const multiplyEth = (eth, multiplier) => {
  const multipliedWeiValue = ethers.parseUnits(eth) * BigInt(multiplier);
  return ethers.formatEther(multipliedWeiValue);
}
const divEth = (eth, divisor) => {
  const dividedWeiValue = ethers.parseUnits(eth) / BigInt(divisor);
  return ethers.formatEther(dividedWeiValue);
}

const infuraProvider = new ethers.InfuraProvider("mainnet", "64e05046ef9d4b55866de25292aee3df");

export default {
  name: 'app',
  computed: {
    isGame() {
      return this.$route.path === '/break' || this.$route.path === '/drop';
    },
    xPostSuccess() {
      let tweetText = 'I just got my spot on the Million Bit Homepage! Go check it out and get yours @BitHomepage';
      let tweetUrl = this.shareUrl;
      if (this.$route.path == '/dob') {
        tweetText = 'I just got my spot on the DOB Pixel Gallery! Go check it out and get yours @doodle_on_base';
        tweetUrl = 'https://www.dob-nft.io/dob-millionpixelpage/';
      }
      return `https://x.com/intent/post?text=${encodeURIComponent(tweetText)}&url=${encodeURIComponent(tweetUrl)}`;
    },
    xPostInvite() {
      return `https://x.com/intent/post?text=${encodeURIComponent('Get your spot on the Million Bit Homepage to be a part of onchain history! @BitHomepage')}&url=${encodeURIComponent(this.shareUrl)}`;
    },
    queryRefCode() {
      let ref = '';
      if (window.location && window.location.search) {
        const urlParams = new URLSearchParams(window.location.search);
        ref = urlParams.get('ref');
      }
      return localStorage.getItem(LOCAL_STORAGE_KEY_REFERRAL) || ref || '';
    },
    deepLinkMetamask() {
      const refCode = this.queryRefCode;
      const host = window.location.host;
      return `https://metamask.app.link/dapp/${host}/${refCode ? `?ref=${refCode}` : ''}`;
    },
    deepLinkCoinbase() {
      const refCode = this.queryRefCode;
      const host = window.location.host;
      return `https://go.cb-w.com/dapp?cb_url=${encodeURIComponent(`https://${host}/${refCode ? `?ref=${refCode}` : ''}`)}`;
    },
    shareUrl() {
      // URL with refCode if available
      let url = 'https://millionbithomepage.com/';
      if (this.refCode) {
        url += `?ref=${this.refCode}`;
      }
      return url;
    },
    ethAmtFormatted() {
      return parseFloat(this.ethAmt).toFixed(3);
    },
  },
  data () {
    return {
      demoMode: DEMO_MODE,
      test_msg: '',
      logoMoji: '💠',
      title: 'Million Bit Homepage',
      tagline: 'Own a bit of onchain history!',
      variant: 'primary',
      variantNavButton: 'outline-light',
      isMobileOrTouch: false,
      touchTimer: null,
      alertMsg: '',
      canBuy: false,
      buyLoading: false,
      canSend: false,
      ethPerPixel: ETH_PIXEL_PRICE,
      ethAmt: "0.000",
      tokenAmt: "0.000",
      tokenPerPixel: TOKEN_PIXEL_PRICE,
      ethTokenToggle: true, // TRUE is ETH
      canToggleEthToken: false, // Can toggle between ETH and token?
      canMint: true, // Enable for NFT minting
      formInputUrl: DEMO_ADDRESS ? 'https://x.com/BitHomepage' : '',
      toggleHomepageList: true,
      requireEthBalance: true,
      isSmartWallet: false,
      trxHashSuccess: '',
      watchedDemo: false,
      email: 'mailto:millionbithomepage@gmail.com',
      telegram: 'https://t.me/+_gBV-0hdCmQzYzgx',
      discord: 'https://discord.gg/WGJwK5jkrU',
      twitter: 'https://x.com/BitHomepage',
      tiktok: 'https://www.tiktok.com/@bithomepage',
      youtube: 'https://www.youtube.com/channel/UCQtsrxAC_JT91CtGtCIxmrg',
      warpcast: 'https://warpcast.com/wopr',
      drakula: 'https://drakula.app/user/million?invite=NfmzCk',
      refCode: '',
      whiteLabel: false,
      contractAddress: config.TOKEN_CA,
      nftAddress: config.NFT_CA,
      symbol: 'BITPIX',
      swapLink: 'https://millionbithomepage.com/', // TODO
      isConnecting: false,
      provider: null,
      connectAccountAddress: '',
      connectAccountAddressTrunc: '',
      providers: [],
      tokenBalance: '',
      connectAccountChainId: '',
      connectAccountEnsName: '',
      connectAccountEnsNameTrunc: '',
      connectAccountEnsAvatar: '',
      connectAccountEnsWebsite: '',
      // Promo until April 1st
      showPromo: false,
      promoMsg: '',
    }
  },
  provide() {
    return {
      updateAppRoute: this.updateAppRoute,
      postToLambda: this.postToLambda,
      saveEvent: this.saveEvent,
      getProviderSigner: this.getProviderSigner,
      doUpload: this.doUpload,
      handleWalletError: this.handleWalletError,
      getGasLimitFromEstimate: this.getGasLimitFromEstimate,
      connectWallet: this.connectWallet,
      appData: () => { return {
        isMobileOrTouch: this.isMobileOrTouch,
        canBuy: this.canBuy,
        
        twitter: this.twitter,
        discord: this.discord,
        telegram: this.telegram,
        email: this.email,
        tiktok: this.tiktok,
        youtube: this.youtube,
        warpcast: this.warpcast,
        drakula: this.drakula,

        connectedAccount: {
          address: this.connectAccountAddress,
          addressTrunc: this.connectAccountAddressTrunc,
          name: this.connectAccountEnsName,
          avatar: this.connectAccountEnsAvatar,
          website: this.connectAccountEnsWebsite,
        }
      }
      },
    }
  },
  methods: {
    showDemoVideo() {
      utils.trackEvent('showDemoVideo');
      this.saveEvent('showDemoVideo', {
      });
      localStorage.setItem(LOCAL_STORAGE_KEY_DEMO_VID, 'true');
      this.watchedDemo = true;
      this.$router.push('demo');
    },
    updateAppRoute: async function(newValue, oldValue) {
      log('updateAppRoute', newValue, oldValue)
      this.toggleHomepageList = false;
      if (newValue === '/') {
        this.resetBuy();
      }

      // TODO cleanup with map
      if (newValue === '/tang') {
        this.contractAddress = config.TANG_CA;
        this.nftAddress = config.NFT_TANG_CA;
        this.symbol = 'TANG'; // TODO fetch from contract
        this.tokenPerPixel = 1; // TODO fetch from contract
        await this.updatePixelPrice();
        await this.updateTokenPixelPrice();
        await this.checkCanPayWithToken();
        this.ethTokenToggle = false;
        this.canToggleEthToken = false;
        this.showPromo = false;

        this.resetBuy();
      } else if (newValue === '/dob') {
        this.whiteLabel = true;
        this.contractAddress = config.SUBPAGES.DOB.TOKEN_CA;
        this.nftAddress = config.SUBPAGES.DOB.NFT_CA;
        this.symbol = 'DOB'; // TODO fetch from contract
        this.tokenPerPixel = 1; // TODO fetch from contract
        await this.updatePixelPrice();
        await this.updateTokenPixelPrice();
        await this.checkCanPayWithToken();
        this.ethTokenToggle = false;
        this.canToggleEthToken = false;
        this.showPromo = false;

        this.resetBuy();
      } else if (newValue === '/preme') {
        this.whiteLabel = false;
        this.contractAddress = config.SUBPAGES.PREME.TOKEN_CA;
        this.nftAddress = config.SUBPAGES.PREME.NFT_CA;
        this.symbol = 'PBP'; // TODO fetch from contract
        this.tokenPerPixel = 1; // TODO fetch from contract
        await this.updatePixelPrice();
        await this.updateTokenPixelPrice();
        await this.checkCanPayWithToken();
        this.ethTokenToggle = true;
        this.canToggleEthToken = false;
        this.showPromo = false;

        this.resetBuy();
      } else {
        this.whiteLabel = false;
        this.contractAddress = config.TOKEN_CA;
        this.nftAddress = config.NFT_CA;
        this.symbol = 'BITPIX';
        this.tokenPerPixel = 1;
        await this.updatePixelPrice();
        await this.checkCanPayWithToken();
        this.ethTokenToggle = true;
        // this.canToggleEthToken = true;
      }
    },
    setPixelsToBuy: function(pixels) {
      this.ethAmt = multiplyEth(this.ethPerPixel.toString(), pixels).toString();
      this.tokenAmt = multiplyEth(this.tokenPerPixel.toString(), pixels).toString();
    },
    validateImageLocation: function(img_offset_x, img_offset_y, img_width, img_height) {
      log('validateImageLocation', img_offset_x, img_offset_y, img_width, img_height)

      // Verify that the img_offset_x and img_offset_y are on the 16 x 16 grid
      if (img_offset_x % 16 !== 0 || img_offset_y % 16 !== 0) {
        // Calculate the difference between the current position and the nearest 16 x 16 grid
        const dx = img_offset_x - (Math.floor(img_offset_x / 16) * 16);
        const dy = img_offset_y - (Math.floor(img_offset_y / 16) * 16);

        // Snap the image to the nearest 16 x 16 grid
        const image = document.getElementById('uploadedImg');
        const x = (img_offset_x || 0) - dx;
        const y = (img_offset_y || 0) - dy;

        // Apply the transformation
        image.style.transform = `translate(${x}px, ${y}px)`;

        // Update the position attributes
        image.setAttribute('data-x', x);
        image.setAttribute('data-y', y);
        img_offset_x = Math.floor(img_offset_x / 16) * 16;
        img_offset_y = Math.floor(img_offset_y / 16) * 16;
      }

      const p = getPriceForPosition(img_offset_x, img_offset_y, img_width, img_height, true);
      if (p) {
        this.setPixelsToBuy(p);
        document.getElementById('million-bit-billboard').classList.remove('tooltip-place');
        this.canSend = true;
        return true;
      } else {
        // Cannot buy this location
        document.getElementById('million-bit-billboard').classList.add('tooltip-place');
        this.canSend = false;
        return false;
      }
    },
    navigateTo: function(route) {
      this.$bvModal.hide('modal-intro');
      if (route === '/') {
        this.toggleHomepageList = true;
      } else {
        this.toggleHomepageList = false;
      }
      this.$router.push(route);
    },
    doToggleEthToken: function(isEth) {
      if (!isEth) {
        this.ethTokenToggle = false;
      } else {
        this.ethTokenToggle = true;
      }
    },
    doUpload: function (x, y) {
      if (this.canBuy) {
        this.cancelBuy();
        return;
      }
      this.uploadToXY = { x, y };
      trackEvent('doUpload:file');
      document.querySelector('input[name="qqfile"]').click()
    },
    doUploadAvatar: async function(event) {
      trackEvent('doUpload:avatar');
      const img = await fetchImage(this.connectAccountEnsAvatar);
      window.manualUploader.addFiles(img);
    },
    connectWallet: async function() {
      trackEvent('connectWallet');
      log('connectWallet');
      this.$bvModal.show('modal-connect');
      this.loadProviders();
      try {
        window.dispatchEvent(new Event("eip6963:requestProvider"));
      } catch (error) {
        log('Error requesting provider', error);
      }
    },
    createWallet: async function() {
      trackEvent('createWallet');
      log('create Wallet');
      this.isConnecting = true;
      
      try {
        const coinbaseWalletSDK = new CoinbaseWalletSDK({
          appName: 'Million Bit Homepage',
          appLogoUrl: 'https://millionbithomepage.com/static/mbh.png',
          appChainIds: [8453],
        });
        const coinbaseWalletProvider = await coinbaseWalletSDK.makeWeb3Provider();
        this.provider = coinbaseWalletProvider;
        log('coinbaseWalletProvider', coinbaseWalletProvider);
        const [address] = await coinbaseWalletProvider.request({
          method: 'eth_requestAccounts',
        });
        log('created Wallet', address, coinbaseWalletProvider);
        await this.setConnectedAccount(address);
        // await this.ensureBaseChain(this.provider);

        // const capabilities = await coinbaseWalletProvider.request({
        //   method: 'wallet_getCapabilities',
        //   // params:[address],
        // });
        // log('capabilities', capabilities);

        this.requireEthBalance = false; // Magic spend // https://www.smartwallet.dev/guides/magic-spend
        this.isSmartWallet = true;
        trackEvent('createdWallet');
        this.isConnecting = false;
      } catch (error) {
        this.isConnecting = false;
        this.handleError(error);
      }
    },
    handleError: function(error) {
      console.error(error);
      this.showAlert('An error occurred. Please try again.');
    },
    getBaseName: async function (address, baseProvider) {
      try {
        const addressReverseNode = utils.convertReverseNodeToBytes(address, 8453); // 8453 is base chain id
        const contract = new ethers.Contract(BASENAME_L2_RESOLVER_ADDRESS, constants.L2ResolverAbi, baseProvider);
        const basename = await contract.name(addressReverseNode);
        return basename;
      } catch (e) {
        console.error('Error getting basename', e)
      }
    },
    getEnsName: async function(address) {
      const ensName = await infuraProvider.lookupAddress(address);
      return ensName;
    },
    getEnsAvatar: async function(ensName) {
      const avatar = await infuraProvider.getAvatar(ensName);
      log(`Avatar for ${ensName} URL: ${avatar}`);
      return avatar;
    },
    getEnsWebsite: async function(ensName) {
      const resolver = await infuraProvider.getResolver(ensName);
      if (resolver) {
        const website = await resolver.getText("url");
        return website;
      }
      return null;
    },
    // resolveEnsAvatar: async function(ensName, provider) {
    //   const resolver = await ethers.EnsResolver.fromName(provider, ensName);
    //   console.log('resolver', resolver)
    //   if (resolver) {
    //       // Resolve the avatar
    //       const avatarUrl = await resolver.getAvatar();
    //       if (avatarUrl) {
    //           console.log(`Avatar URL: ${avatarUrl}`);
    //       } else {
    //           console.log("No avatar found for this ENS name.");
    //       }
    //   } else {
    //       console.log("ENS name not found.");
    //   }
    // },
    setConnectedAccount: async function(account) {
      log('setConnectedAccount', account);
      if(account) {
        // Hide modal
        this.$bvModal.hide('modal-connect');
        this.connectAccountAddress = account;
        this.connectAccountAddressTrunc = account.substring(0, 6) + '…' + account.substring(account.length - 4);

        if (this.$refs.routerViewRef) {
          this.$refs.routerViewRef.$emit('accountConnected', { message: 'Hello from parent' });
        }

        await this.ensureBaseChain(this.provider);

        // Update pixel price for NFT
        await this.updatePixelPrice();
        // Check if they have BITPIX to pay with
        await this.checkCanPayWithToken();

        let { provider, signer } = await this.getProviderSigner();

        const baseName = await this.getBaseName(account, signer);
        if (baseName) {
          this.setEnsName(baseName, 'baseName');
          const ensAvatar = await this.getEnsAvatar(this.connectAccountEnsName);
          this.connectAccountEnsAvatar = ensAvatar || '';
          const ensWebsite = await this.getEnsWebsite(this.connectAccountEnsName);
          if (ensWebsite) {
            this.connectAccountEnsWebsite = ensWebsite;
            this.formInputUrl = ensWebsite;
          } else {
            log(`No website found for address ${this.connectAccountEnsName}`);
            this.connectAccountEnsWebsite = '';
          }
        } else {
          log(`No base name found for address ${this.connectAccountAddress}`);
          const ensName = await this.getEnsName(this.connectAccountAddress);
          if (ensName) {
            this.setEnsName(ensName, 'ensName');
            const ensAvatar = await infuraProvider.getAvatar(this.connectAccountEnsName);
            this.connectAccountEnsAvatar = ensAvatar;
            const resolver = await infuraProvider.getResolver(ensName);
            if (resolver) {
              const website = await resolver.getText("url");
              if (website) {
                log(`The website for this.connectAccountEnsName ${this.connectAccountEnsName} is ${website}`);
                this.connectAccountEnsWebsite = website;
                this.formInputUrl = website;
              } else {
                log(`No website found for address ${this.connectAccountEnsName}`);
                this.connectAccountEnsWebsite = '';
              }
            } else {
              this.connectAccountEnsWebsite = '';
            }
          }
        }
        this.saveEvent('connectedAccount', {
        });
      } else {
        this.connectAccountAddress = '';
        this.connectAccountAddressTrunc = '';
        this.connectAccountEnsName = '';
        this.connectAccountEnsNameTrunc = '';
        this.connectAccountEnsAvatar = '';
        this.connectAccountEnsWebsite = '';
        this.browserProvider = null;
        this.provider = null;
      }
    },
    setEnsName: function(ensName, source) {
      this.connectAccountEnsName = ensName;
      if (this.connectAccountEnsName) {
        this.connectAccountEnsNameTrunc = this.connectAccountEnsName.length > 20 ? this.connectAccountEnsName.substring(0, 20) + '…' : this.connectAccountEnsName;
      } else {
        this.connectAccountEnsNameTrunc = '';
      }
      utils.trackEvent(source+':'+ensName);
      log(source, ensName);
    },
    doConnect: async function(provider) {
      // console.log(provider);
      log('do connect', provider);
      this.isConnecting = true;
      this.isSmartWallet = false;
      this.provider = provider.provider;
      try {
        const accounts = await this.provider
          .request({ method: "eth_requestAccounts" });
        this.setConnectedAccount(accounts[0]);
        // this.ensureBaseChain(this.provider);
        this.isConnecting = false;
      } catch (error) {
        console.error("Failed to connect to provider:", error)
        this.isConnecting = false;
      }
    },
    doDisconnect: async function() {
      try {
        await this.provider.request({ method: "wallet_revokePermissions", "params": [
          {
            "eth_accounts": {}
          }
        ] });
      } catch(e) {
        try {
          this.provider.close();
        } catch(e) {
          console.log('Couldnt close wallet');
        }
      }
      // this.provider = null;
      // this.getWalletPermissions(this.provider);
      log('Disconnect provider', this.provider);
      if (this.provider.disconnect) {
        await this.provider.disconnect();
      }
      await this.setConnectedAccount(null);
    },
    doCopyToClipboard: function(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.showAlert('Copied to clipboard!');
      }).catch(err => {
        console.error('Failed to copy text: ', err);
      });
      // var dummy = document.createElement("textarea");
      // document.body.appendChild(dummy);
      // dummy.value = text;
      // dummy.select();
      // document.execCommand("copy");
      // document.body.removeChild(dummy);
    },
    getWalletPermissions: async function(provider, accounts) {
      if (accounts && accounts.length > 0) {
        this.provider = provider;
        this.setConnectedAccount(accounts[0]);
        // this.ensureBaseChain(provider);
        return;
      }
      if (provider.isCoinbaseBrowser || provider.isCoinbaseWallet) {
        // Not supported
        return;
      }
      const permissions = await provider.request({ method: "wallet_getPermissions" });
      log('getWalletPermissions', permissions);
      accounts = permissions.find(p => p.parentCapability === "eth_accounts");
      log('accounts', accounts);
      if (!accounts || !accounts.caveats) {
        // log('Disconnect provider', provider);
        // if (provider.disconnect) {
        //   provider.disconnect();
        // }
        // this.setConnectedAccount(null);
      } else {
        let eth_accounts = accounts.caveats.find(c => c.type === "restrictReturnedAccounts");
        if (eth_accounts) {
          log('eth accounts', eth_accounts);
          this.provider = provider;
          this.setConnectedAccount(eth_accounts.value[0]);
        } else {
          this.setConnectedAccount(null);
        }
      }
    },
    parseChainId: function(chainId) {
      if (typeof chainId === 'string') {
        if (chainId.startsWith('0x')) {
          return parseInt(chainId, 16).toString();
        } else {
          return chainId;
        }
      } else if (typeof chainId === 'number') {
        return chainId.toString();
      }
    },
    isBaseChain: function(chainId) {
      log('isBaseChain', chainId, typeof chainId, BASE_CHAIN_ID, typeof BASE_CHAIN_ID, this.parseChainId(chainId), this.parseChainId(BASE_CHAIN_ID));
      return this.parseChainId(chainId) === this.parseChainId(BASE_CHAIN_ID);
    },
    switchToBaseChain: function(event) {
      this.ensureBaseChain(this.provider);
    },
    ensureBaseChain: async function(provider) {
      const chainId = await this.getEthChainId(provider);
      this.connectAccountChainId = chainId;
      if (!this.isBaseChain(chainId)) {
        log(`Switching from chain ${chainId} to base ${BASE_CHAIN_ID}`)
        await provider.request({
          "method": "wallet_switchEthereumChain",
          "params": [{ "chainId": BASE_CHAIN_ID.toString() }],
        });
      }
    },
    pollForCompletion: async function(txHash, callback) {
      let calledBack = false;

      let tries = 0;
      const checkInterval = setInterval(async () => {
        tries++;
        if (tries > 30) {
          // Coinbase wallet etc. might not support the method below?
          calledBack = true;
          callback(true);
          return;
        }
        const notYet = 'response has no error or result';
        
        // ethereum.sendAsync({
        try {
          const response = await this.provider.request({
            method: 'eth_getTransactionByHash',
            params: [ txHash ],
          });
          if (calledBack) return;
          console.log('eth_getTransactionByHash', arguments);
          
          // We have successfully verified the mined transaction.
          // Mind you, we should do this server side, with our own blockchain connection.
          // Client side we are trusting the user's connection to the blockchain.
          const transaction = response.result;
          clearInterval(checkInterval);
          calledBack = true;
          this.trxHashSuccess = txHash;
          callback(null, transaction);
        } catch(e) {
          console.log('eth_getTransactionByHash error', arguments)
          if (err || response.error) {
            if (err.message.includes(notYet)) {
              return 'transaction is not yet mined';
            }
            return;
          }
        }
      }, 2000);
    },
    getEthChainId: async function(provider) {
      const chainId = await provider.request({ method: "eth_chainId", "params": [] });
      return chainId;
    },
    watchToken: async function() {
      await this.provider.request({
        "method": "wallet_watchAsset",
        "params": {
          "type": "ERC20",
          "options": {
            "address": config.TOKEN_CA,
            "symbol": this.symbol,
            "decimals": 18,
            "image": TOKEN_IMAGE_URL
          }
        }
      });
    },
    getTokenBalance: async function(p) {
      let provider = new ethers.BrowserProvider(p);
      let signer = await provider.getSigner();
      const contract = new ethers.Contract(this.contractAddress, [
        "function balanceOf(address) view returns (uint256)"
      ], signer);
      const balance = await contract.balanceOf(this.connectAccountAddress);
      log('token balance', balance.toString());
      this.tokenBalance = balance.toString();
      return balance;
    },
    cancelBuy: function (event) {
      this.resetBuy();
    },
    resetBuy: function() {
      this.buyLoading = false;
      this.canBuy = false;
      initUploader(this);
    },
    getPixelPrice: async function(x1, y1, x2, y2) {
      log('Getting pixel price');
      const { provider } = await this.getProviderSigner();
      const contract = new ethers.Contract(this.nftAddress, config.NFT_ABI, provider);
      const price = await contract.calculateCurrentPrice(x1, y1, x2, y2);
      log('Pixel price', price, typeof price);
      return price;
    },
    getTokenPrice: async function() {
      log('Getting pixel price');
      const { provider } = await this.getProviderSigner();
      const contract = new ethers.Contract(this.nftAddress, config.NFT_ABI, provider);
      const price = await contract.tokenPrice();
      console.log(price);
      log('Token Pixel price', price, typeof price);
      return price;
    },
    updatePixelPrice: async function() {
      if (this.canMint) {
        if (!this.connectAccountAddress) {
          log('Cant get pixel price until wallet is connected');
          return 0;
        }
        const blockPrice = await this.getPixelPrice(0,0,16,16);
        this.ethPerPixel = ethers.formatEther(blockPrice / BigInt(16*16));
      }
    },
    updateTokenPixelPrice: async function() {
      if (this.canMint) {
        if (!this.connectAccountAddress) {
          log('Cant get token pixel price until wallet is connected');
          this.$refs.routerViewRef.$on('accountConnected', this.updateTokenPixelPrice);
          return 0;
        }
        const blockPrice = await this.getTokenPrice();
        // this.ethPerPixel = ethers.formatEther(blockPrice / BigInt(16*16));
        this.tokenPerPixel = blockPrice;
      }
    },
    doBuy: async function (event) {
      trackEvent('doBuy');
      trackEvent('begin_checkout');
      this.saveEvent('doBuy', {
      });
      if (!this.connectAccountAddress) {
        this.showAlert('Please connect your wallet first.');
        return;
      }
      if (!this.isBaseChain(this.connectAccountChainId)) {
        this.showAlert('Please switch to base network first.');
        return;
      }

      this.buyLoading = true;

      // Check the image location is still available since the page loaded
      if (false) {
        if (this.$refs.routerViewRef) {
          // Call the method from the child component using the ref
          await this.$refs.routerViewRef.fetchData(true);
        }
        
        // Check for latest image and link data before sending to prevent overlap
        const isLocationValid = this.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
        if (!isLocationValid) {
          this.buyLoading = false;
          this.showAlert('Please review your image placement.');
          return;
        }
      }

      // Refresh pixel price
      try {
        await this.updatePixelPrice();
      } catch(e) {
        console.log(`Error updating pixel price`, e);
      }


      // Load pixel data
      window.pixels_data = getPixelsData(window.myImageData, window.img_width, window.img_height);
      log(window.pixels_data);
      log('pixel data done....');

      const account = this.connectAccountAddress;
      const amountToSend = this.ethTokenToggle ? this.ethAmt : this.tokenAmt;
      this.sendEtherFrom(account, amountToSend, this.ethTokenToggle, async (err, transaction) => {
        // TODO render link to transaction on basescan
        // if (err) {
        //   console.log(err);
        //   trackEvent('trxFailed');
        //   return alert(`The transaction failed.`)
        // }
        this.buyLoading = false;
        trackEvent('purchase');
        trackEvent('trxSuccess');
        
        // Show modal
        await this.getRefCode();
        this.$bvModal.show('modal-success');
        // this.showAlert('Your transaction is being processed.');

        try {
          fetch(WEBHOOK_URL+'?trigger=true', {
            method: 'GET',
          })
          .then(response => {
            if (!response.ok) {
              // throw new Error('Network response was not ok ' + response.statusText);
              console.error('Network response was not ok ' + response.statusText);
            }
            return response.json(); // Assuming the response is JSON
          })
          .then(data => {
            console.log('Data received:', data);
          })
          .catch(error => {
            console.error('Fetch error:', error);
          });
          utils.confetti(10000); // PARTY!

          // Send referral data
          log(transaction);
          const refCode = localStorage.getItem(LOCAL_STORAGE_KEY_REFERRAL);
          this.saveEvent('purchase', {
            code: refCode,
            transaction,
          });
          // if (false && refCode) {
          //   this.postToLambda('trxSuccess', {
          //     code: refCode,
          //     from: account,
          //     transaction
          //   });
          // }
        } catch (e) {
          console.error('Fetch error:', e);
        }
      });
    },
    getEventUserEnv: function() {
      let userEnv = {
        ensName: this.connectAccountEnsName,
        address: this.connectAccountAddress,
        chainId: this.connectAccountChainId,
        agent: navigator.userAgent,
        isMobileOrTouch: this.isMobileOrTouch,
        provider: {
          isCoinbaseWallet: this.provider ? this.provider.isCoinbaseWallet : null,
          isCoinbaseBrowser: this.provider ? this.provider.isCoinbaseBrowser : null,
          isMetaMask: this.provider ? this.provider.isMetaMask : null,
          isRabby: this.provider ? this.provider.isRabby : null,
          isSmartWallet: this.isSmartWallet,
        }
      };
      return userEnv;
    },
    saveEvent: function(eventType, eventData) {
      const userEnv = this.getEventUserEnv();
      this.postToLambda('saveEvent', {
        ...userEnv,
        eventType,
        eventData,
      });
    },
    getRefCode: async function() {
      if (!this.refCode && this.connectAccountAddress) {
        const userEnv = this.getEventUserEnv();
        const response = await this.postToLambda('getRefCode', {
          ...userEnv,
        });
        if (response && response.code) {
          this.refCode = response.code;
        }
      }
      return this.refCode;
    },
    handleWalletError: function(errMsg) {
      const userEnv = this.getEventUserEnv();
      this.postToLambda('walletError', {
        ...userEnv,
        error: errMsg,
      });
      if (errMsg && errMsg.message) {
        errMsg = errMsg.message;
      }
      if (!errMsg) {
        this.showAlert('An error occurred.');
      } else if(errMsg.includes('Insufficient payment')) {
        this.showAlert('Insufficient funds for plot. Please reload the page and try again.');
        trackEvent('walletError:plotClaimed');
      } else if(errMsg.includes('Coordinates overlap')) {
        this.showAlert('This plot has already been claimed.');
        trackEvent('walletError:plotClaimed');
      } else if(errMsg.includes('insufficient funds')) {
        this.showAlert('Insufficient funds for transaction.');
        trackEvent('walletError:insufficientFunds');
      } else if(errMsg.includes('user rejected action')) {
        this.showAlert('User rejected transaction.');
        trackEvent('walletError:reject');
      } else if(errMsg.includes('ERC20: insufficient allowance')) {
        this.showAlert('Please approve the token transfer first.');
        trackEvent('walletError:approve');
      } else if(errMsg.includes('execution reverted') || errMsg.includes('missing revert data')) {
        this.showAlert('Transaction would be reverted.');
        trackEvent('walletError:revert');
      } else {
        this.showAlert(errMsg);
        trackEvent('walletError:unknown');
      }
    },
    getProviderSigner: async function() {
      if(!this.browserProvider) {
        this.browserProvider = await new ethers.BrowserProvider(this.provider);
        // if(DO_LOG) {
        //   this.browserProvider.on("debug", log);
        // }
        this.browserProviderSigner = await this.browserProvider.getSigner();
      }
      log('getProviderSigner', this.browserProvider, this.browserProviderSigner);
      return {
        provider: this.browserProvider,
        signer: this.browserProviderSigner
      }
    },
    sendEtherFrom: async function(account, donation_amount, isEth, callback) {
      trackEvent('trxSending');
      let link_url_el = document.getElementById('link-url');
      var link_url = link_url_el.value;
      
      log('donation amount', donation_amount, typeof donation_amount)
      log('link url', link_url)
      
      if(link_url.indexOf('http') !== 0) {
        this.showAlert('Please provide a URL your image should link to for when someone clicks on it.');
        link_url_el.focus();
        this.buyLoading = false;
        return false;
      }
      
      let pixels_data_strs = [];
      for(var r in window.segmentPrices) {
        for(var c in window.segmentPrices[r]) {
          pixels_data_strs.push(stringDataForEth(window.pixels_data[r][c], link_url, window.segmentPrices[r][c], r, c));
        }
      }
      
      log('pixels_data_strs', pixels_data_strs)
      var pixels_data_str = pixels_data_strs.join('\n');
      var pixels_data_gzip_str = pako.deflate(pixels_data_str, { to: 'string' });
      
      // log('pixels_data_str: '+pixels_data_str);
      log('pixels_data_str length: '+pixels_data_str.length);
      log('pixels_data_gzip_str length: '+pixels_data_gzip_str.length);
      log('compression ratio: '+(pixels_data_str.length/pixels_data_gzip_str.length));

      if (this.demoMode) {
        callback();
        return;
      }

      if (!isEth) {
        if (this.canMint) {
          this.sendPixelsToTokenNFT(pixels_data_gzip_str, donation_amount, account, callback);
        } else {
          this.sendPixelsToToken(pixels_data_gzip_str, donation_amount, account, callback);
        }
        return;
      }

      if (this.canMint) {
        // NFT
        this.sendPixelsToNFT(pixels_data_gzip_str, donation_amount, account, callback);
        return;
      }

      try {
        let trxAmount = ethers.parseEther(donation_amount);
        log('trxAmount', trxAmount, typeof trxAmount);
  
        let { provider, signer } = await this.getProviderSigner();

        if (this.requireEthBalance) {
          // Get wallet balance
          const balance = await provider.getBalance(account);
          log('balance', balance.toString(), trxAmount.toString());
          if (balance < trxAmount) {
            this.buyLoading = false;
            this.showAlert('Insufficient funds for transaction.');
            this.saveEvent('insufficientFunds', {
              trxAmount: trxAmount.toString(),
              balance: balance.toString(),
            });
            return;
          }
        }
  
        // console.log("SEND", account, provider, signer);
        const transactionRequest = {
          to: BID_TO_ADDRESS,
          value: trxAmount,
          data: getEncodedEthDataValue(pixels_data_gzip_str),
        };
        const estimatedGas = await signer.estimateGas(transactionRequest);
        const gasLimit = this.getGasLimitFromEstimate(estimatedGas);

        const transactionRequestWithGasLimit = {
          ...transactionRequest,
          gasLimit: gasLimit,
        };

        this.saveEvent('trxReq', {
          ...transactionRequestWithGasLimit,
          gasLimit: transactionRequestWithGasLimit.gasLimit.toString(),
          value: transactionRequestWithGasLimit.value.toString(),
        });
        
        const tx = await signer.sendTransaction(transactionRequestWithGasLimit);

        // Often you may wish to wait until the transaction is mined
        const receipt = await tx.wait();
        const hash = receipt.hash;
        log('receipt', receipt, hash);
        trackEvent('trxSent');
        this.pollForCompletion(hash, callback);
        this.resetBuy();
      } catch(error) {
        trackEvent('trxFailed');
        console.error('Error sending:', error);
        this.buyLoading = false;
        this.handleWalletError(error);
      }
    },
    sendPixelsToNFT: async function(pixels_data_gzip_str, donation_amount, account, callback) {
      log('sendPixelsToNFT', arguments);
      trackEvent('sendPixelsToNFT');

      let trxAmount = ethers.parseEther(donation_amount);
      log('trxAmount', trxAmount, typeof trxAmount);

      const x1 = window.img_offset_x;
      const y1 = window.img_offset_y;
      const x2 = window.img_offset_x + window.img_width;
      const y2 = window.img_offset_y + window.img_height;
      
      let { provider, signer } = await this.getProviderSigner();
      
      const nftContract = new ethers.Contract(this.nftAddress, config.NFT_ABI, signer);
      const calculatedPrice = await nftContract.calculateCurrentPrice(x1, y1, x2, y2);
      log('calculatedPrice', calculatedPrice, typeof calculatedPrice, ethers.formatEther(calculatedPrice));
      if (this.requireEthBalance) {
        // Get wallet balance
        const balance = await provider.getBalance(account);
        log('balance', balance.toString(), trxAmount.toString());
        if (balance < trxAmount) {
          this.buyLoading = false;
          this.showAlert('Insufficient funds for transaction.');
          this.saveEvent('insufficientFunds', {
            trxAmount: trxAmount.toString(),
            balance: balance.toString(),
          });
          return;
        }
      }

      try {
        const estimatedGas = await nftContract.mint.estimateGas(window.img_offset_x, window.img_offset_y, window.img_offset_x + window.img_width, window.img_offset_y + window.img_height, pixels_data_gzip_str, {value: trxAmount});
        const gasLimit = this.getGasLimitFromEstimate(estimatedGas);
        
        const overrides = {
          gasLimit: gasLimit,
          value: trxAmount,
        };
        const receipt = await nftContract.mint(window.img_offset_x, window.img_offset_y, window.img_offset_x + window.img_width, window.img_offset_y + window.img_height, pixels_data_gzip_str, overrides);
        trackEvent('trxSent');
        console.log('Transaction receipt:', receipt);
        const txHash = receipt.hash;
        this.pollForCompletion(txHash, callback);
        this.resetBuy();
      } catch (error) {
        this.buyLoading = false;
        trackEvent('trxFailed');
        console.error('Error sending:', error);
        this.handleWalletError(error);
      }
    },
    checkCanPayWithToken: async function(tokenOnly) {
      if (!this.connectAccountAddress) {
        return;
      }
      try {
        let { provider, signer } = await this.getProviderSigner();

        const token = new ethers.Contract(this.contractAddress, config.TOKEN_ABI, signer);
        const existingBalance = await token.balanceOf(this.connectAccountAddress);

        console.log('Existing balance:', this.contractAddress, existingBalance.toString());

        if (existingBalance > 0) {
          // if this route page is "tang"
          if (this.$route.path === '/tang' || this.$route.path === '/dob') {
            tokenOnly = true;
          }
          if (!tokenOnly) {
            this.canToggleEthToken = true;
          }
        } else {
          this.canToggleEthToken = false;
        }
      } catch (error) {
        console.error('Error checking token balance:', error);
        this.canToggleEthToken = false;
      }
    },
    sendPixelsToTokenNFT: async function(pixels_data_gzip_str, donation_amount, account, callback) {
      log('sendPixelsToTokenNFT', arguments);
      trackEvent('sendPixelsToTokenNFT');

      const trxAmount = ethers.parseUnits(donation_amount, 18);

      // const x1 = window.img_offset_x;
      // const y1 = window.img_offset_y;
      // const x2 = window.img_offset_x + window.img_width;
      // const y2 = window.img_offset_y + window.img_height;
      
      let { provider, signer } = await this.getProviderSigner();
      
      const nftContract = new ethers.Contract(this.nftAddress, config.NFT_ABI, signer);

      try {  
        const tokenContract = new ethers.Contract(this.contractAddress, config.TOKEN_ABI, signer);

        // Check balance is enough for the transaction
        const existingBalance = await tokenContract.balanceOf(account);
        console.log(`Existing balance: ${existingBalance.toString()}, donation amount: ${donation_amount}`);
        if (existingBalance < trxAmount) {
          this.buyLoading = false;
          this.showAlert(`You don't have enough ${this.symbol} for this transaction`);
          return;
        }
        
        // Approve NFT contract to spend the token
        const approveTrx = await tokenContract.approve(this.nftAddress, trxAmount);
        console.log(`Approved ${trxAmount} tokens for NFT contract:`, approveTrx);
        const approveReceipt = await approveTrx.wait();
        console.log('Approval receipt:', approveReceipt);
        
        // const estimatedGas = await nftContract.tokenMint.estimateGas(window.img_offset_x, window.img_offset_y, window.img_offset_x + window.img_width, window.img_offset_y + window.img_height, pixels_data_gzip_str);
        // const gasLimit = this.getGasLimitFromEstimate(estimatedGas);
        
        // const overrides = {
        //   gasLimit: gasLimit,
        //   // value: trxAmount,
        // };

        const receipt = await nftContract.tokenMint(window.img_offset_x, window.img_offset_y, window.img_offset_x + window.img_width, window.img_offset_y + window.img_height, pixels_data_gzip_str);
        trackEvent('trxSent');
        console.log('Transaction receipt:', receipt);
        const txHash = receipt.hash;
        this.pollForCompletion(txHash, callback);
        this.resetBuy();
      } catch (error) {
        this.buyLoading = false;
        trackEvent('trxFailed');
        console.error('Error sending:', error);
        this.handleWalletError(error);
      }
    },
    sendPixelsToToken: async function(pixels_data_gzip_str, donation_amount, account, callback) {
      log('sendPixelsToToken', arguments);
      trackEvent('sendPixelsToToken');

      const amount = ethers.parseUnits(donation_amount, 18);

      let { provider, signer } = await this.getProviderSigner();

      const token = new ethers.Contract(config.TOKEN_CA, config.TOKEN_ABI, signer);
      const existingBalance = await token.balanceOf(account);

      if (existingBalance < amount) {
        this.buyLoading = false;
        this.showAlert(`You don't have enough ${this.symbol} for this transaction`);
        return;
      }

      try {
        const estimatedGas = await token.paint.estimateGas(BID_TO_ADDRESS, amount, pixels_data_gzip_str);
        const gasLimit = this.getGasLimitFromEstimate(estimatedGas);
        
        const overrides = {
          gasLimit: gasLimit
        };
        const receipt = await token.paint(BID_TO_ADDRESS, amount, pixels_data_gzip_str, overrides);
        trackEvent('trxSent');
        console.log('Transaction receipt:', receipt);
        const txHash = receipt.hash;
        this.pollForCompletion(txHash, callback);
        this.resetBuy();
      } catch (error) {
        this.buyLoading = false;
        trackEvent('trxFailed');
        console.error('Error sending:', error);
        this.handleWalletError(error);
      }
    },
    getGasLimitFromEstimate: function(estimatedGas) {
      const gasLimit = estimatedGas * BigInt(1000) / BigInt(100); // 10x the gas price for coinbase mobile wallet
      log(`Estimated gas: ${estimatedGas}, gasLimit: ${gasLimit}`);
      return gasLimit;
    },
    showAlert: function(msg) {
      this.alertMsg = msg;
      this.$bvModal.show('modal-alert');
    },
    hasProvider: function(name) {
      return this.providers.find(p => p.info.name === name);
    },
    pushProvider: function(p) {
      log('Found provider', p);
      p.on("accountsChanged", (accounts) => {
        log('accountsChanged', accounts);
        this.getWalletPermissions(p, accounts);
      });
      p.on("chainChanged", (chainId) => {
        log('chainChanged', chainId, typeof chainId);
        this.connectAccountChainId = chainId;
      });
      // p.on("disconnect", (error) => {
      //   log('disconnect', error);
      //   this.getWalletPermissions(event.detail.provider);
      // });
      if (p.isPhantom) {
        log('Phantom provider', p);
        if (!this.hasProvider('Phantom')) {
          this.providers.push({
            provider: p,
            info: {
              "uuid": "1",
              "name": "Phantom",
              "icon": "data:image/png;base64,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\n",
              "rdns": "app.phantom"
            }
          });
        }
        this.getWalletPermissions(p);
        trackEvent('hasWallet:app.phantom');
        return;
      }
      if (p.isMetaMask) {
        if (p.isRabby) {
          log('Rabby provider', p);
          this.providers.push({
            provider: p,
            info: {
                "uuid": "aba7b19c-2e24-4405-aff2-69dbd5bbfafd",
                "name": "Rabby",
                "icon": "data:image/svg+xml;base64,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",
                "rdns": "io.rabby"
            }
          });
          this.getWalletPermissions(p);
          trackEvent('hasWallet:io.rabby');
          return;
        }
        log('MetaMask provider', p);
        this.providers.push({
          provider: p,
          info:{
              "uuid": "eb90892c-6a12-44c9-9aea-31a4dd915385",
              "name": "MetaMask",
              "icon": "data:image/svg+xml;base64,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",
              "rdns": "io.metamask"
          }
        });
        this.getWalletPermissions(p);
        trackEvent('hasWallet:io.metamask');
      } else if (p.isCoinbaseWallet || p.isCoinbaseBrowser) {
        log('Coinbase Wallet provider', p);
        this.providers.push({
          provider: p,
          info: {
            "uuid": "22c494ca-e7ca-4c13-a5c0-6d72312046a6",
            "name": "Coinbase",
            "icon": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+",
            "rdns": "com.coinbase.wallet"
          }
        });
        trackEvent('hasWallet:com.coinbase.wallet');
      } else {
        log('Unknown provider', p);
        trackEvent('hasWallet:unknown');
      }
    },
    blurInput() {
      this.$refs.formInputValueUrl.blur()
    },
    initPushNotification() {
      if (!('serviceWorker' in navigator)) {
        // alert('No Service Worker support!')
        return;
      }
      // if (!('PushManager' in window)) {
      //   alert('No Push API Support!')
      //   return;
      // }

      // if ('serviceWorker' in navigator && 'PushManager' in window) {
      console.log('Service Worker and Push are supported');

      // Notification.requestPermission().then(async () => {
      navigator.serviceWorker.register('sw.js').then((swReg) => {
        // alert('Service Worker is registered', swReg);
        this.swRegistration = swReg;
        this.initSubscription();
      }).catch((error) => {
        // alert('Service Worker Error', error);
        // alert(JSON.stringify(error));
      });
      // });
    // } else {
    //   console.warn('Push messaging is not supported');
    //   pushButton.textContent = 'Push Not Supported';
    // }
    },
    initSubscription() {
      // Set the initial subscription value
      this.swRegistration.pushManager.getSubscription().then((subscription) => {
        this.isSubscribed = !(subscription === null);
        this.updateSubscriptionOnServer(subscription);

        if (this.isSubscribed) {
          console.log('User IS subscribed.', subscription);
        } else {
          console.log('User is NOT subscribed.');
          this.subscribeUser();
        }
      })
      .catch((error) => {
        // alert('Error during getSubscription()', error);
      });
    },
    postToLambda: async function(name, data) {
      log('Posting data to lambda', name, data);
      try {
          const response = await fetch(PUSH_SUB_URL+name, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
          })
          if (response.ok) {
            return response.json();
          }
          // .then(response => {
          //   if (!response.ok) {
          //     console.error('Network response was not ok ' + response.statusText);
          //   }
          //   trackEvent('pushSubscribed');
          //   return response.json(); // Assuming the response is JSON
          // })
          // .then(data => {
          //   console.log('Data received:', data);
          // })
          // .catch(error => {
          //   console.error('Fetch error:', error);
          // });
          // utils.toast({
          //   title: `Million Bit Homepage`,
          //   message: `Notifications enabled`,
          //   type: "success",
          //   duration: 5000
          // });
        } catch (e) {
          console.error('Fetch error:', e);
          return undefined;
        }
    },
    updateSubscriptionOnServer(subscription) {
      localStorage.setItem(LOCAL_STORAGE_NOTIFICATION_SUB_ENDPOINT, JSON.stringify(subscription.endpoint));
      if (subscription) {
        console.log('updateSubscriptionOnServer', subscription);
        try {
          fetch(PUSH_SUB_URL+'subscribe', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(subscription),
          })
          .then(response => {
            if (!response.ok) {
              console.error('Network response was not ok ' + response.statusText);
            }
            trackEvent('pushSubscribed');
            return response.json(); // Assuming the response is JSON
          })
          .then(data => {
            console.log('Data received:', data);
          })
          .catch(error => {
            console.error('Fetch error:', error);
          });
          utils.toast({
            title: `Million Bit Homepage`,
            message: `Notifications enabled`,
            type: "success",
            duration: 5000
          });
        } catch (e) {
          console.error('Fetch error:', e);
        }
      }
      // TODO: Send subscription to application server

      // const subscriptionJson = document.querySelector('.js-subscription-json');
      // const subscriptionDetails =
      //   document.querySelector('.js-subscription-details');

      // if (subscription) {
      //   subscriptionJson.textContent = JSON.stringify(subscription);
      //   subscriptionDetails.classList.remove('is-invisible');
      // } else {
      //   subscriptionDetails.classList.add('is-invisible');
      // }
    },
    subscribeUser() {
      const applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
      this.swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      })
      .then((subscription) => {
        console.log('User is subscribed', subscription);

        this.updateSubscriptionOnServer(subscription);

        this.isSubscribed = true;

        // updateBtn();
      })
      .catch((err) => {
        console.log('Failed to subscribe the user: ', err);
        // updateBtn();
      });
    },
    showInviteFriends: async function() {
      await this.getRefCode();
      this.$bvModal.show('modal-invite-friends');
    },
    moveImage(dx, dy, toAbsolute) {
      const image = document.getElementById('uploadedImg');
      let imageX = parseFloat(image.getAttribute('data-x')) || 0;
      let imageY = parseFloat(image.getAttribute('data-y')) || 0;
      if (toAbsolute) {
        dx = dx - imageX;
        dy = dy - imageY;
      }
      let x = imageX + dx;
      let y = imageY + dy;

      // Apply the transformation
      image.style.transform = `translate(${x}px, ${y}px)`;

      // Update the position attributes
      image.setAttribute('data-x', x);
      image.setAttribute('data-y', y);

      window.img_offset_x = x;
      window.img_offset_y = y;
    },
    moveSpot(direction) {
      // var c = document.getElementById("uploadedImg");
      // c.style.display = 'block';
      // c.width = canvas.width;
      // c.height = canvas.height;
      // c.style.width = canvasWidth+'px';
      // c.style.height = canvasHeight+'px';

      if (direction === 'left') {
        this.moveImage(-16, 0);
      } else if (direction === 'right') {
        this.moveImage(16, 0);
      } else if (direction === 'up') {
        this.moveImage(0, -16);
      } else if (direction === 'down') {
        this.moveImage(0, 16);
      }
      this.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
      window.interactable.reflow({ name: 'drag', axis: 'xy' });
    },
    resizeSpot(direction) {
      function scaleImage(increment) {
        const image = document.getElementById('uploadedImg');
        const currentWidth = image.offsetWidth;
        const currentHeight = image.offsetHeight;

        if ((direction === 'bigger' && (currentHeight >= MAX_IMAGE_SIZE || currentWidth >= MAX_IMAGE_SIZE))
          || (direction === 'smaller' && (currentHeight <= 16 || currentWidth <= 16))
        ) {
          return;
        }

        // Calculate the new dimensions
        const newWidth = currentWidth + increment;
        const newHeight = currentHeight + increment;

        // Ensure the image doesn't scale down below a minimum size (e.g., 16x16 pixels)
        if (newWidth >= 16 && newHeight >= 16) {
          image.style.width = `${newWidth}px`;
          image.style.height = `${newHeight}px`;
        }

        window.img_width = newWidth;
        window.img_height = newHeight;

        var destCtx = getScaledContext(window.uploadedImgObj.width, window.uploadedImgObj.height, window.img_width, window.img_height, window.uploadedImgObj.data);
        let d = destCtx.getImageData(0, 0, window.img_width, window.img_height).data
        window.myImageData = d;
      }
      if (direction === 'bigger') {
        scaleImage(16);
      } else if (direction === 'smaller') {
        scaleImage(-16);
      }
      this.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
      window.interactable.reflow({ name: 'drag', axis: 'xy' });
      // window.myImageData = myImageData;
    },
    btnPress(direction) {
      // Your button press logic here
      this.moveSpot(direction);
    },
    handleTouchStart(event, direction) {
      event.preventDefault(); // Prevents text selection and default touch behavior
      // Call btnPress immediately
      this.btnPress(direction);
      this.touchTimer = setTimeout(() => {
        // Start repeating every 500ms
        this.repeatTimer = setInterval(() => {
          this.btnPress(direction);
        }, 100);
      }, 500); // Adjust this timeout for long press sensitivity
    },
    handleTouchEnd(event) {
      event.preventDefault(); // Prevents zooming
      this.handleTouchCancel();
    },
    handleTouchCancel() {
      clearTimeout(this.touchTimer);
      clearInterval(this.repeatTimer);
    },
    loadProviders: function() {
      if(this.providers.length === 0) {
        if (window.ethereum) {
          if(window.ethereum.providers && window.ethereum.providers.length) {
            for (let i = 0; i < window.ethereum.providers.length; i++) {
              const p = window.ethereum.providers[i];
              this.pushProvider(p);
            }
          } else {
            this.pushProvider(window.ethereum);
          }
        } else {
          // this.test_msg = 'no ether'
        }
      } else {
        // this.test_msg = 'has providers'
      }
    },
  },
  watch: {
    // Watch the $route object for changes
    $route(to, from) {
      log('Route changed from', from.path, 'to', to.path);

      // Track the page view with gtag
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path: to.fullPath, // Use the new route's full path
        });
      }
    },
  },
  created: function () {
    log('---------CREATED--------');
    axios.get(utils.getTsPath('config.json')).then((response) => {
      console.log(`---------- CONFIG ---------`)
      console.log(response, response.data);
      const config = response.data;

      if (config.hasOwnProperty('ethPerPixel')) {
        this.ethPerPixel = config.ethPerPixel;
        console.log(`Pixel price: ${config.ethPerPixel}`);
      }

      if (config.hasOwnProperty('promo')) {
        if (config.promo) {
          this.showPromo = config.promo;
          if (config.promo.msg) {
            this.promoMsg = config.promo.msg;
          }
        } else {
          this.showPromo = false;
        }
      }

    });
  },
  mounted() {
    log('---------MOUNTED--------');
    // this.toggleHomepageList = true;
    // initUploader(this); // triggered when child view loads
    // doCountdown();
    this.providers = [];
    setTimeout(()=> {
      this.loadProviders();
    }, 5500); // TODO this sucks, but extending helps fighting wallets

    if (!localStorage.getItem(DID_PROMPT_NOTIFICATIONS)) {
      localStorage.setItem(DID_PROMPT_NOTIFICATIONS, true);
      this.initPushNotification();
    }

    this.watchedDemo = localStorage.getItem(LOCAL_STORAGE_KEY_DEMO_VID);

    this.isMobileOrTouch = utils.isMobileOrTouch();

    // Check for referral code
    if (window.location && window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
      const ref = urlParams.get('ref');
      if (ref) {
        // this.referralCode = ref;
        localStorage.setItem(LOCAL_STORAGE_KEY_REFERRAL, ref);
        this.saveEvent('referral', ref);
      }
    }

    window.addEventListener("eip6963:announceProvider",
      (event) => {
        log('eip6963:announceProvider', event.detail);
        trackEvent('hasWallet:'+event.detail.info.rdns);
        if (event.detail && ['app.phantom'].includes(event.detail.info.rdns)) {
          this.pushProvider(event.detail.provider);
        }
      }
    );
    // setTimeout(()=> {
    //   window.dispatchEvent(new Event("eip6963:requestProvider"));
    // }, 1500);
  }
}
</script>

<style>
.bg-primary {
  background-color: #0063cd !important;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #bebebe;
  margin-top: 0px;
}
#million-bit-billboard {
  position: relative;
}
#million-bit-billboard.tooltip-place::after {
    content: "⬇️ Place your image on an empty spot on the canvas";
    text-align: left;
    display: block;
    height: 40px;
    width: 1024px;
    position: absolute;
    left: 0px;
    background: #ffffe5;
    top: -45px;
    font-weight: bold;
    padding: 8px;
    border: 1px solid black;
    border-radius: 5px;
}
.mbh-title {
  font-size: 60px;
  color: #fff; /* for mobile that doesn't support color fonts */
  cursor: pointer;
  line-height: 1em;
}
.subtitle {
  font-size: 0.8em;
  color: #e8e8e8;
}
.header-l, .header-r {
  min-width: 280px;
}
.btn.btn-outline-light {
 background-color: #00000021;
 /* text-transform: uppercase; */
 border-color: #f8f9fa59;
}
.btn.btn-outline-lighter {
 background-color: #0000;
 /* text-transform: uppercase; */
 border-color: #f8f9fa59;
}
.btn-outline-light:hover {
  background-color: #f8f9fa;
}
.nav-buttons .btn {
  min-width: 120px;
}

.btn-warning {
  min-width: 160px;
  font-weight: bold;
  border-radius: 5px !important;
}

#uploadedImg,
#uploadedImg * {
  -ms-touch-action: none;
  touch-action: none;
}
html {
  min-width: 1024px;
}
#uploadedImg {
  background: white;
}
#countdown {
  font-size: 1em;
  color: #393939;
  width: 420px;
  margin: 50px auto;
}
#countdown ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  background: #1a1a1a;
  border-radius: 4px;
}
#countdown li {
  display: inline-block;
  font-size: 1.0em;
  list-style-type: none;
  padding: 1em;
  text-transform: uppercase;
  
  border: 1px solid #0000001a;
  width: 108px;
  color: #707070;
}

#countdown li span {
  display: block;
  font-size: 2.5rem;
  color: white;
  font-family: 'Honk'
}
.connect-menu, .nav-menu {
  /* height: 120px; */
}
#modal-connect img {
  max-height: 2em;
  margin-right: 4px;
}
#modal-connect .btn {
  text-align: left;
}
.connect-menu button.btn.btn-connect, #create-wallet {
  min-width: 200px;
  border-color: #f8f9fa59;
}
.connect-menu a {
  border-color: #f8f9fa59;
}
.connect-menu img {
  max-height: 22px;
}
.disconnect svg {
  max-height: 20px;
}
.loader {
  position: absolute;
  width: 22px; /* control the size */
  aspect-ratio: 1;
  display: grid;
  -webkit-mask: conic-gradient(from 22deg, #0003,#000);
          mask: conic-gradient(from 22deg, #0003,#000);
  animation: load 1s steps(8) infinite;
}
.loader,
.loader:before {
  --_g: linear-gradient(#616161 0 0) 50%; /* update the color here */
  background: 
    var(--_g)/34% 8%  space no-repeat,
    var(--_g)/8%  34% no-repeat space;
}
.loader:before {
  content: "";
  transform: rotate(45deg);
}
@keyframes load {
  from {transform: rotate(0turn)}
  to   {transform: rotate(1turn)}
}

.text-bold {
  font-weight: bold;
}

@keyframes confetti-slow {
  0% {
    transform: translate3d(0, 0, 0) rotateX(0) rotateY(0);
  }
  100% {
    transform: translate3d(25px, 105vh, 0) rotateX(360deg) rotateY(180deg);
  }
}
@keyframes confetti-medium {
  0% {
    transform: translate3d(0, 0, 0) rotateX(0) rotateY(0);
  }
  100% {
    transform: translate3d(100px, 105vh, 0) rotateX(100deg) rotateY(360deg);
  }
}
@keyframes confetti-fast {
  0% {
    transform: translate3d(0, 0, 0) rotateX(0) rotateY(0);
  }
  100% {
    transform: translate3d(-50px, 105vh, 0) rotateX(10deg) rotateY(250deg);
  }
}
.confetti-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  z-index: 99999;
}
.c-container {
  width: 100vw;
  height: 100vh;
}

.confetti-container {
  perspective: 700px;
  position: absolute;
  overflow: hidden;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.confetti {
  position: absolute;
  z-index: 1;
  top: -10px;
  border-radius: 0%;
}
.confetti--animation-slow {
  animation: confetti-slow 2.25s linear 1 forwards;
}
.confetti--animation-medium {
  animation: confetti-medium 1.75s linear 1 forwards;
}
.confetti--animation-fast {
  animation: confetti-fast 1.25s linear 1 forwards;
}


/* ======= Toast message ======== */

#toast {
  position: fixed;
  bottom: 32px;
  right: 32px;
  z-index: 999999;
  box-sizing: border-box;
}

.toaster {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 2px;
  padding: 20px 0;
  min-width: 400px;
  max-width: 450px;
  border-left: 4px solid;
  box-shadow: 0 5px 8px rgba(0, 0, 0, 0.08);
  transition: all linear 0.3s;
  box-sizing: border-box;
  text-align: left;
}
@media screen and (max-device-width: 768px) {
  #toast {
    scale: 2;
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(calc(100% + 32px));
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeOut {
  to {
    opacity: 0;
  }
}

.toast-success {
  border-color: #0063cd;
}

.toast-success .toast_icon {
  color: #47d864;
}

.toast-info {
  border-color: #2f86eb;
}

.toast-info .toast_icon {
  color: #2f86eb;
}

.toast-warning {
  border-color: #ffc021;
}

.toast-warning .toast_icon {
  color: #ffc021;
}

.toast-error {
  border-color: #ff623d;
}

.toast-error .toast_icon {
  color: #ff623d;
}

.toast + .toast {
  margin-top: 24px;
}

.toast_icon {
  font-size: 24px;
}

.toast_icon,
.toast_close {
  padding: 0 16px;
}

.toast_body {
  flex-grow: 1;
}

.toast_title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.toast_msg {
  font-size: 14px;
  color: #888;
  margin-top: 6px;
  line-height: 1.5;
}

.toast_close {
  font-size: 20px;
  color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.btn-icon {
  min-width: 50px !important;
}

.ensAvatar {
  max-height: 22px;
}

.header-m .form-inline {
  justify-content: space-between;
}

#pfp-vid-container {
  cursor: pointer;
  position: fixed;
  bottom: 26px;
  right: 26px;
  height: 78px;
  width: 78px;
}
#pfp-vid {
  width: 100%;             /* Adjust width as needed */
  height: 100%;          /* Show only the top third */
  overflow: hidden;        /* Hide the rest of the video */
  position: relative;
  border-radius: 50%;
  box-shadow: 0px 0px 18px white;
  border: 2px solid #afafaf;
}
#pfp-vid div {
}
#pfp-vid video {
  width: 100%;
  height: auto;            /* Keep aspect ratio */
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
}

/* .mbh-footer {
  font-size: 1.2em;
} */

/* on mobile screens */
@media screen and (max-device-width: 768px) {
  /* .mbh-footer {
    font-size: 1.2em;
  } */
  #pfp-vid-container {
    bottom: 26px;
    right: 26px;
    height: 132px;
    width: 132px;
  }
  .loader {
    width: 66px;
  }
  .mbh-title {
    font-size: 100px;
  }
  #app > .navbar .mr-0 {
    width: 100%;
  }
  .connect-menu img {
    max-height: 50px;
  }
  .nav-buttons .btn {
    min-width: calc(20vw);
  }
  .btn, .form-control {    
    font-size: 2.8rem;
  }
  input#link-url {
    /* max-width: 180px; */
    width: 100%;
    margin-bottom: 18px;
    order: -1;
  }
  .subtitle {
    font-size: 0.8em !important;
  }
  .header-l {
    order: 0;
  }
  .header-r {
    order: 1;
  }
  .header-l, .header-r {
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .header-m {
    order: 2;
  }
  .connect-menu button.btn.btn-outline-light {
    /* min-width: 50%; */
    /* font-size: 2rem; */
  }
  .modal-dialog {
    max-width: 90%;
  }
  body {
    font-size: 2rem;
  }
  #countdown {
    width: 80%;
  }
  #countdown li {
    width: 24%;
    padding: 1em 0px;
  }
  #countdown li span {
    font-size: 4.5rem;
  }
  #million-bit-billboard.tooltip-place::after {
    height: 60px;
    top: -60px;
  }
  .nav-buttons .btn.btn-icon {
    min-width: 80px !important;
  }
  .btn-icon svg {
    scale: 2;
  }
  .ensAvatar {
    max-height: 50px;
  }
  .modal-header .close {
    scale: 2;
  }
  .modal-backdrop {
    bottom: 0;
    right: 0;
    width: auto;
    height: auto;
  }
}

#mobile-controls {
  position: fixed;
  bottom: 0;
  height: 250px;
  left: 0;
  right: 0;
  background: #0063cd;
  z-index: 999999;

  /* Prevent default selection */
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
#mobile-controls > div {
  border: 2px solid white;
  border-radius: 8px;
  background: #ffffff52;
  width: 120px;
  height: 120px;
  padding: 14px;
}

#mobile-controls > div > svg {
  height: 100%;
  width: 100%;
}
#control-left {
  position: absolute;
  top: 25%;
  left: calc(50vw - 64px - 120px);
}
#control-right {
  position: absolute;
  top: 25%;
  left: calc(50vw + 64px);
}
#control-up {
  position: absolute;
  left: calc(50vw - 60px);
}
#control-down {
  position: absolute;
  left: calc(50vw - 60px);
  bottom: 0;
}
#control-bigger {
  position: absolute;
  top: 0;
  right: 0;
}
#control-smaller {
  position: absolute;
  bottom: 0;
  right: 0;
}
#copyright {
  font-size: 1em;
}
body > canvas {
  /* Prevent stretching mobile scroll horizontal */
  max-width: 100%;
}
.send-feedback img {
  max-height: 18px;
}

.promo-header {
  width: 100%;
  clear: both;
  background: #7ceafd;
  font-size: 1.2em;
  border-bottom: rgb(0, 7, 140) 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/App.vue?42186324